import React, { Suspense } from "react";
import {
  defaultSampleData,
  ISampleViewData,
} from "../../models/sample/SampleViewData";
import Summary from "../sharedNew/Summary";
import {
  AppTopNavi,
  Menu,
  MenuItem,
  Button,
  Dialog,
  Icon,
  Tooltip,
  WithTooltip,
} from "@abb/abb-common-ux-react";
import * as CONSTANTS from "../../utilities/Constants";
import { Translation } from "react-i18next";
import measurementActions from "../../flux/actions/MeasurementActions";
import triggerNotifications from "../../utilities/TriggerNotifications";
import { v4 as uuidv4 } from "uuid";
import MeasurementStartStore from "../../flux/stores/measurement/MeasurementStartStore";
import {
  IInstrumentDetails,
  defaultInstrumentDetails,
  IMeasurementProperties,
  InstrumentDetails,
  IPositionMeans,
  IReadings,
} from "../../models/measurement/InstrumentDetails";
import KeyedInDetailsStore from "../../flux/stores/measurement/KeyedInDetailStore";
import CalculatedDetailsStore from "../../flux/stores/measurement/CalculatedDetailStore";
import MeasurementPauseStore from "../../flux/stores/measurement/MeasurementPauseStore";
import MeasurementStopStore from "../../flux/stores/measurement/MeasurementStopStore";
import MeasurementDetailsStore from "../../flux/stores/measurement/MeasurementDetailsStore";
import SampleInstrumentDetailsStore from "../../flux/stores/measurement/SampleInstrumentDetailsStore";
import SelectedInstrumentSampleDetails from "../../flux/stores/measurement/SelectedInstrumentSampleDetails";
import measurementSettingStore from "../../flux/stores/settings/MeasurementSettingStore";
import {
  MEASUREMENT_HUB,
  MEASUREMENT_HUB_RECEIVE_MEASUREMENT,
  HUB_SETCONTEXT,
  MEASUREMENT_HUB_RECEIVE_MEASUREMENT_COUNT,
  INSTRUMENT_HUB,
  MEASUREMENT_HUB_RECEIVE_INSTRUMENT_STATUS,
  MEASUREMENT_HUB_RECEIVE_KEYEDIN,
  MEASUREMENT_HUB_RECEIVE_KEYEDIN_COUNT,
  STATUS_HUB,
  SAMPLE_HUB_RECEIVE_SAMPLE_STATUS,
  MEASUREMENT_HUB_RECEIVE_KEYEDIN_STATUS,
  MEASUREMENT_HUB_RECEIVE_CALCULATED_PROPERTY,
  EXCEPTION_HUB,
  HANDLE_EXCEPTION,
  MEASUREMENT_HUB_RECEIVE_AL_STATUS,
  MEASUREMENT_AL_HUB,
  RE_TRY_ATTEMPTS,
} from "../../utilities/HubConstants";
import * as signalR from "@microsoft/signalr";
import { Status } from "../../models/sample/Status";
import APIErrorCode from "../../utilities/ErrorCode.json";
import {
  defaultCalculatedDetails,
  ICalculatedDetails,
} from "../../models/measurement/CalculatedDetails";
import IMeasuredDetails, {
  defaultMeasurementDetailsData,
} from "../../models/measurement/MeasuredDetails";
import MeasurementKeyedInStore from "../../flux/stores/measurement/MeasurementKeyedInStore";
import MeasurementRejectStore from "../../flux/stores/measurement/MeasurementRejectStore";
import MeasurementApproveStore from "../../flux/stores/measurement/MeasurementApproveStore";
import {
  defaultKeyedInDetails,
  IKeyedInDetails,
  KeyedInDetails,
} from "../../models/measurement/KeyedInDetails";
import {
  defaultKeyedInDetailsData,
  KeyedInDetailsData,
} from "../../models/measurement/KeyedInDetailsData";

import checkInstrumentInUse from "../../flux/stores/sample/CheckInstrumentInUse";
import sampleActions from "../../flux/actions/SampleActions";
import thresholdSettingStore from "../../flux/stores/settings/ThresholdSettingStore";
import settingsActions from "../../flux/actions/SettingsAction";
import { ISampleOverviewData } from "../../models/sample/SampleOverviewData";
import { IReportPropertyData } from "../../models/sample/ReportProperties";

import Toast from "../../utilities/Toaster";
import History from "../../utilities/History";
import sampleExportStore from "../../flux/stores/sample/ExportStore";
import actionHeaderEditStore from "../../flux/stores/shared/ActionHeaderEditStore";
import IActionHeaderFormData, {
  IActionHeaderEditData,
} from "../../models/shared/ActionHeaderData";
import actionHeaderCommonStore from "../../flux/stores/shared/ActionHeaderCommonStore";
import IThresholdSettings from "../../models/settings/ThresholdSettings";
import CalculatedPropertyDetails from "./CalculatedPropertyDetails";
import _ from "lodash";
import sampleInstruementLastReamesure from "../../flux/stores/sample/InstruementLastReamesure";
import sampleinstrumentSkipCountinPosition from "../../flux/stores/sample/instrumentSkipCountinPosition";
import sampleinstrumentEndPosition from "../../flux/stores/sample/instrumentEndPosition";
import { IExportOptions } from "../../models/settings/MeasurementSettings";
import Authorize from "../../utilities/Authorize";
import authUtility from '../../utilities/AuthUtility';
import i18next from "i18next";

const MeasurementLanding = React.lazy(
  () => import("../sampleNew/MeasurementLanding")
);
const MeasurementTable = React.lazy(
  () => import("../sampleNew/MeasurementTable")
);
const MeasurementOverview = React.lazy(() => import("./MeasurementOverview"));
const InstrumentProperty = React.lazy(
  () => import("../sampleNew/InstrumentProperty")
);
const InstrumentPropertyDetails = React.lazy(
  () => import("../sampleNew/InstrumentPropertyDetails")
);
const KeyedInProperty = React.lazy(
  () => import("../sampleNew/KeyedInProperty")
);
const KeyedInPropertyDetails = React.lazy(
  () => import("../sampleNew/KeyedInPropertyDetails")
);

interface ISidebarProps {
  // side bar collapsed
  sidebarCollapsed: boolean;
  activeItem: any;
  sampleData: any;
  statusChangeHandler: (status: any) => void;
  onDelete: (e: string) => any;
  childRef?: any;
  toastMsg?: string;
  isToast?: boolean;
  showToastMessage?: (e: boolean) => any;
}

interface IMeasurementLandingState {
  activeTab: any;
  sampleId: string;
  sampleData: any;
  gridView: boolean;
  isInstrumentPropertyDetails: boolean;
  isInstrumentProperty: boolean;
  isKeyedInProperty: boolean;
  isKeyedInPropertyDetails: boolean;
  measurementDetails: any;
  sampleInstrumentDetails: any;
  stopMeasurement: boolean;
  startMeasurement: boolean;
  isPaused: boolean;
  isComplete: boolean;
  keyedInDetailsData: any;
  keyedInSampleData: any;
  activeDirectionIndx: any;
  selectedInstrumentDetail: IInstrumentDetails;
  selectedKeyedInDetails?: IKeyedInDetails;
  selectedCalculatedDetails?: ICalculatedDetails;
  selectedDirection?: any[];
  selectedPosition: any;
  selectedPositionFromMeasuring: any;
  calculatedDetailsData: any;
  showPauseDialog: boolean;
  showStopDialog: boolean;
  showInstrumentRemeasureDialog: boolean;

  showRemeasureDialog: boolean;
  isSetActive: boolean
  showInstrumentStopDialog: boolean;
  pauseLoading: boolean;
  stopLoading: boolean;
  thresholdSettings: IThresholdSettings[];
  isReportDropdownShow: boolean;
  isExportShow: boolean;
  isMenuNarrow: boolean;
  exportId: any;
  downloadData: any;
  toastMsg: string;
  showToast: boolean;
  moduleName: string;
  editData: any;
  deleteTitle: string;
  deleteId: string;
  isEnableViewAll: boolean;
  deleteRequesId: string;
  deleteMessage: string;
  isEnableReport: boolean;
  isSampleWithScanner: boolean;
  deleteModalVisible: boolean;
  isEditShow: boolean;
  isCalculatedPropertyDetails: boolean;
  lastEnteredValue: any[];
  isSubmitDisabled: boolean;
  countValue: any;
  sampleXML: boolean,
  measurementXML: boolean,
  measurementXLS: boolean,
  exportSample: boolean,
  exportMeasurement: boolean,
  keyedInCountFromHub: any,
  settingsData: any,
  isLoading: boolean,
  resumeLoading: boolean,
  remeasureLoading: boolean,
  completeLoading: boolean,
  approveLoading: boolean,
  rejectLoading: boolean,
  startLoading: boolean,
  shadowIsSetActive: boolean,
}

export default class Landing extends React.Component<
  ISidebarProps,
  IMeasurementLandingState
> {
  private _messages: any = [];
  private _goToMeasurement: any;
  private _message: any;
  private _mount: boolean = false;
  private _measurementDetails: IMeasuredDetails;
  private _keyedInDetails: any;
  private _calculatedDetails: ICalculatedDetails[];
  private _measurementConnection: signalR.HubConnection;
  private _instrumentConnection: signalR.HubConnection;
  private _sampleConnection: signalR.HubConnection;
  private _exceptionConnection: signalR.HubConnection;
  private _autolineConnection: signalR.HubConnection;
  private _stopMeasurement: boolean = false;
  private _isMeasurementRejected: boolean;
  private _isMeasurementAproved: boolean = false;
  private _keyedInData: any[] = [];

  private _sampleInstrumentDetails: any;
  private _selectedInstrument: any;
  private _autolineProperties: IMeasurementProperties[] = [];
  private _selectedInstrumentId: any;
  private _selectedPosition: any = 0;
  private _settingsData: any;
  private _currentMeasuringProperty: string;
  private _currentMeasuringPosition: number;
  private _checkInstrument: any;
  private _currentInstrumentId: string;
  private _thresholdSettings: IThresholdSettings[];

  /* START -> Measurement Overview private variable */
  start = new Date(2019, 0, 1, 0, 0, 0, 0);
  end = new Date(2019, 0, 5, 0, 0, 0, 0);

  private minXValue: number;
  private maxXValue: number;

  private _sampleData: ISampleViewData = defaultSampleData;
  private _sampleOverviewData: ISampleOverviewData;
  private _isValid: boolean = false;
  private _reportData: IReportPropertyData[];
  private _measuredPositionData: any[];
  private _calculatedPositionData: any[];
  private _keyedinPositionData: any[];
  /* END -> Measurement Overview */
  private _lastKeyedInDetails: any[] = [];
  private _onReportClick: boolean = true;
  private _onExportCall: boolean = true;
  private _onEditCall: boolean = true;

  constructor(props: any) {
    super(props);
    this._mount = true;
    this.state = {
      activeTab: [0],
      sampleId: this.props.sampleData?.id || "",
      sampleData: this.props.sampleData || defaultSampleData,
      gridView: true,
      isInstrumentPropertyDetails: false,
      isInstrumentProperty: false,
      isKeyedInProperty: false,
      isKeyedInPropertyDetails: false,
      stopMeasurement: false,
      startMeasurement: false,
      isPaused: false,
      isComplete: false,
      showPauseDialog: false,
      showStopDialog: false,
      showRemeasureDialog: false,
      isSetActive: false,
      showInstrumentRemeasureDialog: false,
      showInstrumentStopDialog: false,
      pauseLoading: false,
      stopLoading: false,
      isReportDropdownShow: false,
      isMenuNarrow: false,
      isExportShow: false,
      exportId: "",
      downloadData: "",
      toastMsg: "",
      showToast: false,
      moduleName: "",
      editData: {},
      deleteTitle: "",
      deleteId: "",
      isEnableViewAll: false,
      deleteRequesId: "",
      deleteMessage: "",
      isEnableReport: false,
      isSampleWithScanner: false,
      deleteModalVisible: false,
      activeDirectionIndx: 0,
      thresholdSettings: [],
      selectedDirection: [],
      selectedPosition: {},
      sampleInstrumentDetails: {}, // instrument mode measurement
      keyedInSampleData: [], // total number of  keyedin value in sample
      selectedInstrumentDetail: defaultInstrumentDetails, // single details
      selectedKeyedInDetails: defaultKeyedInDetails, // single details
      selectedCalculatedDetails: defaultCalculatedDetails, // single details
      measurementDetails: defaultMeasurementDetailsData, // multiple details
      keyedInDetailsData: [], // multiple details
      calculatedDetailsData: [], // multiple details
      isEditShow: false,
      isCalculatedPropertyDetails: false,
      lastEnteredValue: [],
      isSubmitDisabled: true,
      countValue: 0,
      selectedPositionFromMeasuring: null,
      sampleXML: false,
      measurementXML: false,
      measurementXLS: false,
      exportSample: false,
      exportMeasurement: false,
      keyedInCountFromHub: {},
      settingsData: {},
      isLoading: false,
      resumeLoading: false,
      remeasureLoading: false,
      completeLoading: false,
      approveLoading: false,
      rejectLoading: false,
      startLoading: false,
      shadowIsSetActive: false
    };
  }

  componentDidMount() {
    this._mount = true;

    this.hubCall();
    this.hubCallEvent();

    this.setState({ isSetActive: false })

    actionHeaderCommonStore.on(
      CONSTANTS.CHANGE_EVENT,
      (state: IActionHeaderFormData) => {
        if (this._mount) {
          this.setState({
            moduleName: state.moduleName,
          });
        }
      }
    );

    actionHeaderEditStore.on(
      CONSTANTS.CHANGE_EVENT,
      (state: IActionHeaderEditData) => {
        if (this._mount) {
          this.setState({
            moduleName: state.moduleName,
            editData: state.editData,
            deleteTitle: state.deleteTitle,
            deleteId: state.deleteId,
            isEnableViewAll: state.isEnableViewAll || false,
            exportId: state.exportId,
            deleteRequesId: state.deleteRequestId,
            deleteMessage: state.deleteMessage,
            isEnableReport: state.isEnableReport,
            isSampleWithScanner: false,
          });
        }
      }
    );

    Object.defineProperty(WebSocket, "OPEN", {
      value: 1,
    });

    this.actionCall();
    this.storeCall();
    this.GetExportOptions();
  }

  private GetExportOptions = () => {
    const request: string[] = [
      "ExportSample",
      "ExportMeasurement",
    ];
    settingsActions.getExportOptions(request).then((res: IExportOptions[]) => {
      if (res && res.length) {
        let exportSample = false;
        let exportMeasurement = false;
        res.forEach((x: IExportOptions) => {
          if (x.key === "ExportSample") {
            exportSample = x.value === "True" ? true : false
          } else if (x.key === "ExportMeasurement") {
            exportMeasurement = x.value === "True" ? true : false
          }
        })
        this.setState({
          exportSample,
          exportMeasurement
        })
      }

    }).catch((er) => { console.log(er) });
  };
  actionCall() {
    this.getGeneralSettings();
    this.getThresholdValues();
  }

  private getThresholdValues = () => {
    settingsActions
      .getThresholdReport()
      .then(() => {
        this.setState({
          thresholdSettings: this._thresholdSettings,
        });
      })
      .catch((e) => {
        triggerNotifications.error(e);
      });
  };

  private getGeneralSettings = () => {
    settingsActions
      .getGeneral()
      .then(() => {
        this.setState({ settingsData: this._settingsData })
      })
      .catch((e: any) => {
        triggerNotifications.error(e);
      });
  };

  componentDidUpdate(previousProps: any) {
    if (previousProps.sampleData.id !== this.props.sampleData.id) {
      this._measurementConnection
        .stop()
        .then(() => console.log("STOPPED FROM DIDMOUNT"))
        .catch(() => {
          console.log("Measurement Hub Stopped");
        });
      this._sampleConnection.stop().then(() => {
      });
      this.setState(
        {
          sampleData: this.props.sampleData,
          measurementDetails: {}, // measurementDetailsData
          keyedInDetailsData: [],
          calculatedDetailsData: {},
          isInstrumentProperty: false,
          isInstrumentPropertyDetails: false,
          isKeyedInProperty: false,
          isKeyedInPropertyDetails: false,
          isCalculatedPropertyDetails: false,
          activeTab: [0],
          isSetActive: false,
        },
        () => {
          console.log(this._sampleConnection.state);
          // get initial data from API

          if (
            this.state.sampleData?.status?.name === "Measuring" ||
            this.state.sampleData?.status?.name === "Stopped" ||
            this.state.sampleData?.status?.name === "Paused"
          ) {
            this.getInitialData(true, true);
          } else {
            setTimeout(() => {
              this.measurementHubStart();
            }, 1000);
          }
        }
      );
    }
    if (previousProps.toastMsg !== this.props.toastMsg) {
      this.setState({
        toastMsg: this.props?.toastMsg ?? "",
        showToast: this.props?.isToast ?? false,
      });
    }
  }

  storeCall() {
    MeasurementRejectStore.on(CONSTANTS.CHANGE_EVENT, (state) => {
      if (this._mount) {
        this._isMeasurementRejected = state.isMeasurementRejected;
      }
    });

    thresholdSettingStore.on(CONSTANTS.CHANGE_EVENT, (state: any) => {
      if (this._mount) {
        this._thresholdSettings = state.data;
      }
    });

    checkInstrumentInUse.on(CONSTANTS.CHANGE_EVENT, (state) => {
      console.log("STATE ", state);
      this._checkInstrument = state.instrumentData.data;
    });

    MeasurementStartStore.on(CONSTANTS.CHANGE_EVENT, (state) => {
      console.log("STATE ", state);
      this._message = state.message;
      this._goToMeasurement = state.isMeasurementStart;
    });

    KeyedInDetailsStore.on(CONSTANTS.CHANGE_EVENT, (state) => {
      this._keyedInDetails = state.data;
    });

    CalculatedDetailsStore.on(CONSTANTS.CHANGE_EVENT, (state) => {
      this._calculatedDetails = state.data;
    });

    MeasurementPauseStore.on(CONSTANTS.CHANGE_EVENT, (state) => {
      if (this._mount) {
        const data = state.data;
      }
    });

    MeasurementStopStore.on(CONSTANTS.CHANGE_EVENT, (state) => {
      if (this._mount) {
        this._stopMeasurement = true;
      }
    });
    MeasurementDetailsStore.on(CONSTANTS.CHANGE_EVENT, (state) => {
      if (this._mount) {
        this._measurementDetails = state.data;
      }
    });

    SampleInstrumentDetailsStore.on(CONSTANTS.CHANGE_EVENT, (state: any) => {
      if (this._mount) {
        this._sampleInstrumentDetails = state.data;
      }
    });

    SelectedInstrumentSampleDetails.on(CONSTANTS.CHANGE_EVENT, (state: any) => {
      if (this._mount) {
        this._selectedInstrument = state.data;
      }
    });

    measurementSettingStore.on(CONSTANTS.CHANGE_EVENT, (state: any) => {
      if (this._mount) {
        this._settingsData = state.data;
      }
    });

    MeasurementKeyedInStore.on(CONSTANTS.CHANGE_EVENT, (state: any) => {
      if (this._mount) {
        this._keyedInData = state.data;
      }
    });

    MeasurementRejectStore.on(CONSTANTS.CHANGE_EVENT, (state) => {
      if (this._mount) {
        this._isMeasurementRejected = state.isMeasurementRejected;
      }
    });

    MeasurementApproveStore.on(CONSTANTS.CHANGE_EVENT, (state) => {
      if (this._mount) {
        this._isMeasurementAproved = state.isMeasurementAproved;
      }
    });

    sampleInstruementLastReamesure.on(CONSTANTS.CHANGE_EVENT, (state) => {
      if (this._mount) {
        this._message = state.message;
      }
    });

    sampleinstrumentSkipCountinPosition.on(CONSTANTS.CHANGE_EVENT, (state) => {
      if (this._mount) {
        this._message = state.message;
      }
    });

    sampleinstrumentEndPosition.on(CONSTANTS.CHANGE_EVENT, (state) => {
      if (this._mount) {
        this._message = state.message;
      }
    });

    sampleExportStore.on(CONSTANTS.CHANGE_EVENT, (state) => {
      if (this._mount) {
        this.setState({
          downloadData: state.downloadData,
        });
      }
    });
  }

  hubCall() {
    /* ======================================== */
    // SET Measurement Connection HUB
    this._measurementConnection = new signalR.HubConnectionBuilder()
      .withUrl(MEASUREMENT_HUB)
      .configureLogging(signalR.LogLevel.Information)
      .withAutomaticReconnect(RE_TRY_ATTEMPTS)
      .build();

    // START MEASUREMENT HUB BY DEFAULT
    this.measurementHubStart();

    // On onreconnecting show the notification to user.
    this._measurementConnection.onreconnecting(() => {
      triggerNotifications.error(CONSTANTS.RE_CONNECTING);
    });

    // On Reconnected the Measurement Hub set the new context.
    this._measurementConnection.onreconnected(() => {
      this._measurementConnection
        .send(HUB_SETCONTEXT, this.state.sampleData.id)
        .then()
        .catch((err) => console.log(err)); // setcontext for measurement hub call by sample ID
      triggerNotifications.success([CONSTANTS.RE_CONNECTED]);
    });

    /* ======================================== */

    // SET INSTRUMENT CONNECTION HUB
    this._instrumentConnection = new signalR.HubConnectionBuilder()
      .withUrl(INSTRUMENT_HUB)
      .withAutomaticReconnect(RE_TRY_ATTEMPTS)
      .build();

    /* ======================================== */

    this._sampleConnection = new signalR.HubConnectionBuilder()
      .withUrl(STATUS_HUB)
      .withAutomaticReconnect(RE_TRY_ATTEMPTS)
      .build();

    this._sampleConnection.on(
      SAMPLE_HUB_RECEIVE_SAMPLE_STATUS,
      (sampleId: string, statusId: string, statusName: Status) => {
        if (this._mount) {
          if (sampleId === this.state.sampleData.id) {
            if (statusName === Status.MEASURED) {
              let tempIndex: number;
              if (this.state.selectedKeyedInDetails.id) {
                tempIndex = this._lastKeyedInDetails.findIndex(
                  (x: any) =>
                    x.keyedInPropertyId === this.state.keyedInDetailsData[0].id
                );
              } else {
                tempIndex = this._lastKeyedInDetails.findIndex(
                  (x: any) =>
                    x.keyedInPropertyId === this.state.keyedInDetailsData[0].id
                );
              }
              this._lastKeyedInDetails = this._lastKeyedInDetails.slice(
                1,
                tempIndex
              );
              const status = {
                id: "68005087-9871-4b0a-8b00-c2e4e4e67856",
                name: "Measured",
              };
              setTimeout(() => {
                this.props.statusChangeHandler(status);
                this.setState({
                  lastEnteredValue: [],
                  isInstrumentPropertyDetails: false,
                  isInstrumentProperty: false,
                  isKeyedInProperty: false,
                  isKeyedInPropertyDetails: false,
                });
              }, 350);

            } else if (statusName === Status.STOPPED) {
              this.setState({
                stopMeasurement: true,
                startMeasurement: false,
                isPaused: false,
              });
            } else if (statusName === Status.PAUSED) {
              this.setState({
                stopMeasurement: false,
                startMeasurement: false,
                isPaused: true,
              });
            } else if (statusName === Status.APPROVED) {
              const status = {
                id: "805be14e-c6f7-47cd-b756-fcec1defaf7a",
                name: Status.APPROVED,
              };
              setTimeout(() => {
                this.props.statusChangeHandler(status);
                this.setState({
                  lastEnteredValue: [],
                  isInstrumentPropertyDetails: false,
                  isInstrumentProperty: false,
                  isKeyedInProperty: false,
                  isKeyedInPropertyDetails: false,
                });
              }, 0);
            } 
            else {
              const status = {
                id: "63242767-D573-4295-BC36-64CB1DDC0AFD",
                name: "Measuring",
              };
              setTimeout(() => {
                this.props.statusChangeHandler(status);
                this.setState({
                  stopMeasurement: true,
                  startMeasurement: false,
                  isPaused: false,
                });
              }, 0);
            }
          }
        }
      }
    );

    /* ======================================== */

    this._exceptionConnection = new signalR.HubConnectionBuilder()
      .withUrl(EXCEPTION_HUB)
      .withAutomaticReconnect(RE_TRY_ATTEMPTS)
      .build();

    this.exceptionHubStart();

    this._exceptionConnection.on(HANDLE_EXCEPTION, (message: string) => {
      if (this._mount) {
        if (message !== undefined) {
          const messages = [];
          const str = message.substring(1, message.length - 1);
          const elm = str.split(":");
          const eCode = APIErrorCode.ErrorCode.find(
            (x) => x["Message code "] === elm[0]
          );
          if (eCode !== undefined) {
            if (elm[1].length > 1) {
              messages.push(eCode.Message);
            } else if (elm[1].length > 2) {
              const messageTwo = eCode.Message.format(elm[1][0], elm[1][1]);
              messages.push(messageTwo);
            } else {
              messages.push(eCode.Message);
            }

            triggerNotifications.errors(messages).then();
          }
        }
      }
    });

    /* ======================================== */

    this._autolineConnection = new signalR.HubConnectionBuilder()
      .withUrl(MEASUREMENT_AL_HUB)
      .withAutomaticReconnect(RE_TRY_ATTEMPTS)
      .build();

    this.autolineHubStart();

    this._autolineConnection.on(
      MEASUREMENT_HUB_RECEIVE_AL_STATUS,
      (instrumentId: string, status: boolean) => {
        console.log("AUTOLINE HUB CONNECTION ", instrumentId, " --- ", status);

        if (status) {
          this.getAllInstrumentDetails();
        }
      }
    );
  }

  private getSampleCalculatedDetailsApiCall = () => {
    // Calculated API CALL is made as it doesnot have a hub call
    measurementActions
      .getSampleCalculatedDetails(
        this.state.sampleData.id,
        this.state.measurementDetails.measurementId
      )
      .then(() => {
        if (this._mount) {
          if (this._calculatedDetails.length > 0) {
            this.setState({
              calculatedDetailsData: this._calculatedDetails,
            });
          }
        }
      });
  };

  /**
   * Function is used for hub call namespace
   */
  public hubCallEvent() {
    // RECEIVE MEASUREMENT DETAILS DATA FROM MEASUREMENT HUB
    this._measurementConnection.on(
      MEASUREMENT_HUB_RECEIVE_MEASUREMENT,
      (
        sampleId: string,
        measurementId: string,
        instrumentId: string,
        propertyId: string,
        directionId: string,
        position: number,
        currentCount: number,
        value: any,
        valueRange: any,
        statistics: any
      ) => {
        console.log(
          "RECEIVE MEASUREMENT DETAILS DATA FROM MEASUREMENT HUB :>> ",
          sampleId,
          measurementId,
          instrumentId,
          propertyId,
          directionId,
          position,
          currentCount,
          value,
          valueRange,
          statistics
        );

        if (
          this.state.measurementDetails.measurementId === measurementId &&
          this.state.sampleData.id === sampleId
        ) {
          const measurementDetails = { ...this.state.measurementDetails };
          const instrumentDetails = [...measurementDetails.instrumentDetails];
          const instrumentDetail = measurementDetails.instrumentDetails.find(
            (x: any) => x.id === instrumentId
          );
          const instrumentDetailIndex =
            measurementDetails.instrumentDetails.findIndex(
              (x: any) => x.id === instrumentId
            );
          const posMean = instrumentDetail.positionMeans.find(
            (x: any) =>
              x.propertyId === propertyId &&
              x.position === position &&
              x.directionId === directionId
          );
          const positionName = (instrumentDetail.directionCounts || []).find(
            (eles: any) => eles.position === position
          );

          if (posMean) {
            posMean.mean = statistics.mean;
            posMean.position = position;
          } else if (
            instrumentDetail.positionMeans &&
            instrumentDetail.positionMeans.length
          ) {
            instrumentDetail.positionMeans.push({
              propertyId,
              position,
              mean: statistics.mean,
              positionName: positionName?.name ?? "",
              directionId,
            });
          } else {
            instrumentDetail.positionMeans = [
              {
                propertyId,
                position,
                mean: statistics.mean,
                positionName: positionName?.name ?? "",
                directionId,
              },
            ];
          }

          const valueRangeData = { id: "", name: valueRange };
          instrumentDetail.setAverage(
            propertyId,
            directionId,
            position,
            statistics
          );
          const selectedProp = instrumentDetail?.properties.find(
            (x: any) => x.id === propertyId
          );

          instrumentDetail.setReadings(
            currentCount,
            directionId,
            position,
            propertyId,
            value,
            valueRangeData,
            "",
            selectedProp?.decimals
          );
          let previousDirectionMeans: any = [];
          if (instrumentDetail.readings && instrumentDetail.readings.length) {
            previousDirectionMeans =
              instrumentDetail.readings[0].directionMeans || [];
            let isDirAvail = previousDirectionMeans.findIndex(
              (elems: any) =>
                elems.directionId === directionId &&
                elems.propertyId === propertyId
            );
            if (isDirAvail >= 0) {
              let positionMeanVal = (
                instrumentDetail.positionMeans || []
              ).filter(
                (el: any) =>
                  el.directionId === directionId && el.propertyId === propertyId
              );

              let mean =
                positionMeanVal && positionMeanVal.length
                  ? positionMeanVal
                    .filter((elments: any) => elments.mean && elments.mean !== "NaN")
                    .reduce((partialSum: any, a: any) => {
                      return partialSum + Number(a.mean);
                    }, 0) /
                    positionMeanVal.filter((x:any) => x.mean !== "NaN" && x.mean !== null).length
                  : 0;

              previousDirectionMeans.splice(isDirAvail, 1, {
                directionId,
                propertyId,
                mean,
              });
            } else {
              previousDirectionMeans.push({
                directionId,
                propertyId,
                mean: statistics?.mean ?? 0,
              });
            }
          }
          instrumentDetail.readings.forEach((el: any) => {
            el.directionMeans = previousDirectionMeans;
            if (!el.positionName) {
              const positionNamereading = (
                instrumentDetail.directionCounts || []
              ).find((eles: any) => eles.position === el.position);
              el.positionName = positionNamereading?.name ?? "";
            }
            if (!el.propertyName) {
              const propertyName = (instrumentDetail.properties || []).find(
                (x: any) =>
                  x.id === el.propertyId && x.directionId === el.directionId
              );
              el.propertyName = propertyName?.name ?? "";
            }
          });

          this._currentMeasuringProperty = propertyId;
          this._currentMeasuringPosition = position;
          instrumentDetail.currentMeasuringPosition = position;
          instrumentDetail.setCurrentMeasuringProperty(propertyId, position);
          instrumentDetails[instrumentDetailIndex] = instrumentDetail;

          const dir = instrumentDetail.allDirections.find((x: any) => {
            return x.id === directionId;
          });

          const dropdownlabel: any = {
            isNew: false,
            itemTemplate: undefined,
            label: dir?.name,
            menuItemTemplate: undefined,
            selectedItemTemplate: undefined,
            value: dir?.id,
          };

          const selectedPositionFromMeasuring = {
            position: position,
            instrumentId: instrumentId,
          };

          this.setState(
            {
              selectedDirection: [dropdownlabel],
              selectedPositionFromMeasuring,
              measurementDetails: {
                ...this.state.measurementDetails,
                instrumentDetails,
              },
            },
            () => this.forceUpdate()
          );
        }
      }
    );

    // RECEIVE COUNT DATA FROM MEASUREMENT HUB
    this._measurementConnection.on(
      MEASUREMENT_HUB_RECEIVE_MEASUREMENT_COUNT,
      (
        sampleId: any,
        measurementId: any,
        instrumentId: any,
        position: number,
        directionCount: any,
        positionCount: any,
        count: any
      ) => {
        console.log(
          "RECEIVE COUNT DATA FROM MEASUREMENT HUB :>> ",
          sampleId,
          measurementId,
          instrumentId,
          position,
          directionCount,
          positionCount,
          count
        );
        if (
          this.state.measurementDetails.measurementId === measurementId &&
          this.state.sampleData.id === sampleId
        ) {
          const measurementDetails = { ...this.state.measurementDetails };
          const instrumentDetails = [...measurementDetails.instrumentDetails];
          const instrumentDetail = measurementDetails.instrumentDetails.find(
            (x: any) => x.id === instrumentId
          );
          const instrumentDetailIndex =
            measurementDetails.instrumentDetails.findIndex(
              (x: any) => x.id === instrumentId
            );
          this._selectedPosition = position;
          let activeDirectionIndex = this.state.activeDirectionIndx;
          instrumentDetail.updateDirectionCount(
            position,
            directionCount.directionId,
            directionCount.completedCounts
          );
          instrumentDetail.setCount(count);

          instrumentDetail.setMeasuredPosition(position);
          instrumentDetail.setCurrentMeasuringProperty(
            this._currentMeasuringProperty,
            this._currentMeasuringPosition
          );
          let updatdPosCont = instrumentDetail.positionCount.findIndex(
            (x: any) => x.position === positionCount.position
          );
          instrumentDetail.positionCount[updatdPosCont].selected = true;
          instrumentDetail.positionCount[updatdPosCont].completedCounts =
            positionCount.completedCounts;
          instrumentDetail.positionCount[updatdPosCont].totalCounts =
            positionCount.totalCounts;
          instrumentDetail.setPositionCount(instrumentDetail.positionCount);
          instrumentDetail.setCount(count);
          instrumentDetail.setDirectionCount(
            position,
            directionCount.directionId,
            directionCount.completedCounts
          );
          instrumentDetail.nextMeasuringPositionDireaction =
            instrumentDetail.getNextMeasuringDetails(
              instrumentDetail.countData,
              instrumentDetail.allDirections,
              this.state.sampleData.testPlan,
              instrumentDetail.readings
            );
          instrumentDetails[instrumentDetailIndex] = instrumentDetail;

          const allDirectionsObj: any = {};
          instrumentDetail.allDirections.forEach((alldir: any, i: number) => {
            allDirectionsObj[alldir.name] = alldir;
            if (this.state.sampleData?.testPlan?.isPDC) {
              if (directionCount.directionId === alldir.id) {
                if (
                  directionCount.completedCounts === directionCount.totalCounts
                ) {
                  activeDirectionIndex = activeDirectionIndex + 1;
                  if (
                    instrumentDetail?.countData[position]?.directions[0]
                      ?.totalCounts ===
                    instrumentDetail?.countData[position]?.directions[0]
                      ?.completedCounts &&
                    positionCount.position !==
                    instrumentDetail?.countData.length - 1
                  ) {
                    ++position;
                    instrumentDetail?.countData.forEach((element: any) => {
                      element.selected = false;
                    });
                    positionCount.position = position;
                    instrumentDetail.countData[position].selected = true;
                    instrumentDetail.setPositionVal = position;
                    instrumentDetail.setMeasuredPosition(position);
                    activeDirectionIndex = 0;
                  }
                } else {
                  activeDirectionIndex = i;
                }
              }
            } else {
              if (directionCount.directionId === alldir.id) {
                if (
                  directionCount.completedCounts === directionCount.totalCounts
                ) {
                  activeDirectionIndex = activeDirectionIndex + 1;
                  if (
                    instrumentDetail?.countData[position]?.directions[
                      activeDirectionIndex
                    ]?.maxCount ===
                    instrumentDetail?.countData[position]?.directions[
                      activeDirectionIndex
                    ]?.completedCounts &&
                    positionCount.position !==
                    instrumentDetail?.countData.length - 1
                  ) {
                    ++position;
                    instrumentDetail?.countData.forEach((element: any) => {
                      element.selected = false;
                    });
                    positionCount.position = position;
                    instrumentDetail.countData[position].selected = true;
                    instrumentDetail.setPositionVal = position;
                    instrumentDetail.setMeasuredPosition(position);
                    activeDirectionIndex = i;
                  } else if (
                    positionCount.position ===
                    instrumentDetail?.countData.length - 1
                  ) {
                    position = 0;
                    instrumentDetail?.countData.forEach((element: any) => {
                      element.selected = false;
                    });
                    positionCount.position = position;
                    instrumentDetail.countData[position].selected = true;
                    instrumentDetail.setPositionVal = position;
                    instrumentDetail.setMeasuredPosition(position);
                  }
                } else {
                  activeDirectionIndex = i;
                }
              }
            }
          });

          this.setState({
            selectedInstrumentDetail: instrumentDetail,
            activeDirectionIndx: activeDirectionIndex,
            measurementDetails: {
              ...this.state.measurementDetails,
              instrumentDetails,
            },
            selectedPosition: instrumentDetail.countData.find(
              (elmenstss: any) =>
                elmenstss.position ===
                (instrumentDetail.nextMeasuringPositionDireaction.position ||
                  position)
            ),
          }, () => {
            this.setMeasuredActiveTab()
          });
        }
      }
    );

    // INSTRUMENT (MEASURED PROPERTY) STATUS HUB
    this._instrumentConnection.on(
      MEASUREMENT_HUB_RECEIVE_INSTRUMENT_STATUS,
      (instrumentId: string, statusId: string, statusName: string) => {
        console.log(
          "INSTRUMENT (MEASURED PROPERTY) STATUS HUB :>> ",
          instrumentId,
          statusId,
          statusName
        );
        console.log(this._sampleConnection.state);
        const measurementDetails = { ...this.state.measurementDetails };
        const instrumentDetails = [...measurementDetails.instrumentDetails];
        const instrumentDetail = measurementDetails.instrumentDetails.find(
          (x: any) => x.id === instrumentId
        );
        const instrumentDetailIndex =
          measurementDetails.instrumentDetails.findIndex(
            (x: any) => x.id === instrumentId
          );

        instrumentDetail.setStatus({ id: instrumentId, name: statusName });
        instrumentDetails[instrumentDetailIndex] = instrumentDetail;

        this.setState({
          measurementDetails: {
            ...this.state.measurementDetails,
            instrumentDetails,
          },
        });
      }
    );

    // Calculated Receive data from hub
    this._measurementConnection.on(
      MEASUREMENT_HUB_RECEIVE_CALCULATED_PROPERTY,
      (
        sampleId: string,
        measurementId: string,
        propertyId: string,
        value: number,
        valueRange: string,
        position: number,
        count: number
      ) => {
        console.log(
          "Calculated Receive data from hub :>> ",
          sampleId,
          measurementId,
          propertyId,
          value,
          valueRange,
          position,
          count
        );
        const calculatedDetailsData: ICalculatedDetails[] = [
          ...this.state.calculatedDetailsData,
        ];
        const calculatedDetail = calculatedDetailsData.find(
          (x) => x.id === propertyId
        );
        const calculatedDetailIndex = calculatedDetailsData.findIndex(
          (x) => x.id === propertyId
        );
        const calculatedValuesFind = calculatedDetail.calculatedValues.find(
          (x) => x.count === count
        );
        if (
          calculatedValuesFind !== undefined ||
          calculatedValuesFind !== null
        ) {
          calculatedDetail.calculatedValues.push({
            count,
            position,
            value,
            valueRange: { id: "", name: valueRange },
          });
        }
        calculatedDetailsData[calculatedDetailIndex] = calculatedDetail;
      }
    );

    // RECEIVE KEYEDIN DATA FROM HUB
    this._measurementConnection.on(
      MEASUREMENT_HUB_RECEIVE_KEYEDIN,
      (
        sampleId: string,
        measurementId: string,
        propertyId: string,
        directionId: string,
        position: number,
        currentCount: number,
        value: number,
        valueRange: any,
        statistics: any
      ) => {
        console.log(
          "RECEIVED KEYEDIN :>> ",
          sampleId,
          measurementId,
          propertyId,
          directionId,
          position,
          currentCount,
          value,
          statistics
        );

        if (
          this.state.keyedInDetailsData[0].measurementId === measurementId &&
          this.state.sampleData.id === sampleId
        ) {
          const keyedInDetailsDataArray = [...this.state.keyedInDetailsData];
          const keyedInDetailsData = keyedInDetailsDataArray.find(
            (x: any) => x.id === propertyId
          );
          const keyedInDetailsDataIndex = keyedInDetailsDataArray.findIndex(
            (x: any) => x.id === propertyId
          );

          const keyedInDetail = keyedInDetailsData.keyedInDetails[0];
          keyedInDetail.setAverage(
            propertyId,
            directionId,
            position,
            statistics
          );

          const positionName = (keyedInDetail.positionCounts || []).find(
            (x: any) => x.position === position
          );
          let isPositionMeansAvail = (
            keyedInDetail.positionMeans || []
          ).findIndex(
            (x: any) => x.position === position && x.directionId === directionId
          );
          if (isPositionMeansAvail >= 0) {
            keyedInDetail.positionMeans.splice(isPositionMeansAvail, 1, {
              directionId: directionId,
              mean: statistics.mean,
              position,
              propertyId,
              positionName: positionName?.name ?? "",
            });
          } else {
            keyedInDetail.positionMeans.push({
              directionId: directionId,
              mean: statistics.mean,
              position,
              propertyId,
              positionName: positionName?.name ?? "",
            });
          }
          let propertyMeanVal = keyedInDetail.positionMeans || [];
          let propertyMean =
            propertyMeanVal && propertyMeanVal.length
              ? propertyMeanVal
                .filter((elments: any) => elments.mean && elments.mean !== "NaN")
                .reduce((partialSum: any, a: any) => {
                  return partialSum + Number(a.mean);
                }, 0) /
                propertyMeanVal.filter((x:any) => x.mean !== "NaN" && x.mean !== null).length
              : 0;
          keyedInDetail.propertyMean = {
            mean: propertyMean,
            propertyId,
          };

          keyedInDetailsDataArray[keyedInDetailsDataIndex].keyedInDetails[0] =
            keyedInDetail;
          keyedInDetailsDataArray[keyedInDetailsDataIndex].lastEnteredValue =
            value; // assigning the value to the last entered keyedin value

          const temp = this._lastKeyedInDetails.findIndex(
            (x: any) => x.keyedInPropertyId === propertyId
          );
          if (temp !== -1) {
            this._lastKeyedInDetails[temp] = {
              lastEnteredValue: value,
              keyedInPropertyId: propertyId,
            };
          } else {
            this._lastKeyedInDetails.push({
              lastEnteredValue: value,
              keyedInPropertyId: propertyId,
            });
          }
          this.setState({
            keyedInDetailsData: keyedInDetailsDataArray,
          });
        }
      }
    );

    // KEYEDIN STATUS HUB
    this._measurementConnection.on(
      MEASUREMENT_HUB_RECEIVE_KEYEDIN_STATUS,
      (propertyId: string, statusId: string, statusName: string) => {
        console.log(
          "KEYEDIN STATUS HUB :>> ",
          propertyId,
          " -- ",
          statusId,
          " -- ",
          statusName
        );
      }
    );

    // RECEIVE KEYEDIN COUNTS
    this._measurementConnection.on(
      MEASUREMENT_HUB_RECEIVE_KEYEDIN_COUNT,
      (
        sampleId: string,
        measurementId: string,
        propertyId: string,
        position: any,
        directionCount: any,
        positionCount: any,
        count: any
      ) => {
        console.log(
          "RECEIVE KEYEDIN COUNTS :>> ",
          propertyId,
          position,
          directionCount,
          positionCount,
          count
        );

        if (
          this.state.keyedInDetailsData[0].measurementId === measurementId &&
          this.state.sampleData.id === sampleId
        ) {
          const keyedInDetailsDataArray = [...this.state.keyedInDetailsData];
          const keyedInDetailsData = keyedInDetailsDataArray.find(
            (x: any) => x.id === propertyId
          );
          const keyedInDetailsDataIndex = keyedInDetailsDataArray.findIndex(
            (x: any) => x.id === propertyId
          );

          const keyedInDetail = keyedInDetailsData.keyedInDetails[0];
          keyedInDetail.updateDirectionCount(
            position,
            directionCount.directionId,
            directionCount.completedCounts
          );
          keyedInDetail.setCount([count]);
          if (positionCount.totalCounts === positionCount.completedCounts) {
          } else {
            keyedInDetail.setPositionValue(positionCount.position);
          }
          keyedInDetailsDataArray[keyedInDetailsDataIndex].keyedInDetails[0] =
            keyedInDetail;
          const keyedInDataFromHub = this.state.keyedInDetailsData?.filter((i: any) => i.id === this.state.selectedKeyedInDetails.id);
          const keyedInCountFromHub = keyedInDataFromHub.length !== 0 ? keyedInDataFromHub[0].keyedInDetails[0].counts : ""
          this.setState({
            keyedInDetailsData: keyedInDetailsDataArray,
            keyedInCountFromHub: keyedInCountFromHub
          }, () => {
            this.setKeyedInActiveTab();
          });
        }
      }
    );
  }

  private getKeyedInDetailsFromHub(
    keyedInDetailsData: any,
    keyedInDetailsDataIndex: number
  ) {
    measurementActions
      .getSampleKeyedInDetails(
        this.state.sampleData.id,
        this.state.measurementDetails.measurementId
      )
      .then(() => {
        if (this._mount) {
          if (this._keyedInData.length > 0) {
            this.setState(
              {
                keyedInSampleData: this._keyedInData,
              },
              () => {
                const selectedKeyedIn =
                  this.state.keyedInSampleData[keyedInDetailsDataIndex];
                measurementActions
                  .getKeyedInDetails(
                    this.state.measurementDetails.id,
                    this.state.measurementDetails.measurementId,
                    selectedKeyedIn.id
                  )
                  .then(() => {
                    const keyedInDetail: IKeyedInDetails[] = [];
                    keyedInDetail.push(
                      new KeyedInDetails(
                        selectedKeyedIn.id,
                        selectedKeyedIn.name,
                        [selectedKeyedIn.count],
                        this._keyedInDetails.directionCounts,
                        selectedKeyedIn.status,
                        this._keyedInDetails.positionCounts,
                        selectedKeyedIn.unit,
                        this._keyedInDetails.readings,
                        this._keyedInDetails.propertyMean,
                        this._keyedInDetails.positionMeans,
                        this._keyedInDetails.statistics,
                        selectedKeyedIn.decimals
                      )
                    );

                    this.setState(
                      {
                        selectedKeyedInDetails: keyedInDetail[0],
                      },
                      () => {
                        console.log(this.state.selectedKeyedInDetails);
                      }
                    );
                  })
                  .catch((err) => console.log(err));
              }
            );
          }
        }
      });
  }

  private setMeasuredActiveTab = () => {
    const a = this.state.measurementDetails.instrumentDetails.filter((i: any) => i.status.name === "Completed")
    const x = this.state.keyedInDetailsData.filter((i: any) => i.keyedInDetails[0].completionPercentage === "100%")
    let b: any = [0]
    if (a.length === this.state.measurementDetails.instrumentDetails.length &&
      x.length !== this.state.keyedInDetailsData.length) {
      b = [1];
    } else {
      b = [0];
    }
    setTimeout(() => {
      this.setState({ activeTab: b })
    }, 150);
  }

  private setKeyedInActiveTab = () => {
    const a = this.state.measurementDetails.instrumentDetails.filter((i: any) => i.status.name === "Completed")
    const x = this.state.keyedInDetailsData.filter((i: any) => i.keyedInDetails[0].completionPercentage === "100%")
    let b: any = [0]
    if (x.length === this.state.keyedInDetailsData.length &&
      a.length !== this.state.measurementDetails.instrumentDetails.length) {
      b = [0];
    } else {
      b = [1];
    }
    setTimeout(() => {
      this.setState({ activeTab: b })
    }, 150);
  }

  private autolineHubStart = () => {
    this._autolineConnection
      ?.start()
      .then()
      .catch((error) => {
        console.log("ERROR AUTOLINE HUB  :>> ", error);
        this._autolineConnection.stop().then(() => {
          this.autolineHubStart();
        });
      });
  };

  private measurementHubStart = () => {
    if (this._measurementConnection.state === "Disconnected") {
      this._measurementConnection
        ?.start()
        .then(() => {
          this._measurementConnection
            .send(HUB_SETCONTEXT, this.state.sampleData.id)
            .then()
            .catch((err) => console.log(err)); // setcontext for measurment hub call by sample ID
        })
        .catch((error) => {
          console.log("ERROR HUB  :>> ", error);
          this._measurementConnection.stop().then(() => {
            this.measurementHubStart();
          });
        });
    }
  };

  private instrumentHubStart = (ids: any) => {

    this._instrumentConnection
      ?.start()
      .then(() => {
        this._instrumentConnection
          .send(HUB_SETCONTEXT, ids) // setcontext for instrument hub call by instrument ID
          .then()
          .catch((error) => console.log(error));
      })
      .catch((err) => {
        console.log("ERROR HUB  :>> ", err);
        this._instrumentConnection.stop().then(() => {
          this.instrumentHubStart(ids);
        });
      });
  };

  private measurementHubStop = () => {
    this._measurementConnection
      ?.stop()
      .then(() => {
        triggerNotifications.info("STOPPING MEASUREMENT CONNETION HUB");
      })
      .catch(() => {
        this.error("Measurement Hub Error Occured");
      });
  };

  private sampleHubStart = () => {
    this._sampleConnection
      .start()
      .then(() => {
        console.log(this.state.sampleData.name);
        this._sampleConnection
          .send(HUB_SETCONTEXT, this.state.sampleData.id)
          .then()
          .catch((error) => {
            // setcontext for sample hub call by sample ID
            console.log(error);
          });
      })
      .catch((err) => {
        console.log("ERRORHUB SAMPLE ", err);
        this._sampleConnection.stop().then(() => {
          this.sampleHubStart();
        });
      });
  };

  private exceptionHubStart = () => {
    this._exceptionConnection
      .start()
      .then()
      .catch((err) => {
        console.log("ERRORHUB EXECPTION ", err);
        this._exceptionConnection.stop().then(() => {
          this.exceptionHubStart();
        });
      });
  };

  private error = (message: string) => {
    triggerNotifications.error(message).then();
  };

  private getDefaultInstrumentdata = (selectedInstrumentId?: string) => {
    measurementActions
      .getInstrumentMeasurementDetails(
        this.state.measurementDetails.id,
        this.state.measurementDetails.measurementId
      )
      .then(() => {
        const instrumentDetails: IInstrumentDetails[] = [];
        this._sampleInstrumentDetails.map((data: any) => {
          instrumentDetails.push(
            new InstrumentDetails(
              data.id,
              data.name,
              data.count,
              [],
              [],
              [],
              data.instrumentStatus,
              [],
              [],
              [],
              [],
              data.isAutoLine
            )
          );
        });

        this.setState(
          {
            sampleInstrumentDetails: this._sampleInstrumentDetails,
            measurementDetails: {
              ...this.state.measurementDetails,
              instrumentDetails,
            },
          },
          () => {
            const selectedInstrument = this.state.sampleInstrumentDetails.find(
              (x: any) => x.id === selectedInstrumentId
            );
            measurementActions
              .getInstrumentDetails(
                this.state.measurementDetails.id,
                this.state.measurementDetails.measurementId,
                selectedInstrumentId
              )
              .then(() => {
                const instrumentDetailIndex =
                  this.state.measurementDetails.instrumentDetails.findIndex(
                    (x: any) => x.id === selectedInstrument.id
                  );
                const selectedInstrumentDetail = new InstrumentDetails(
                  this._selectedInstrument.id,
                  this._selectedInstrument.name,
                  selectedInstrument.count,
                  this._selectedInstrument.directionCounts,
                  this._selectedInstrument.properties,
                  this._selectedInstrument.readings,
                  selectedInstrument.instrumentStatus,
                  this._selectedInstrument.positionCounts,
                  this._selectedInstrument.statistics,
                  this._selectedInstrument.propertyMeans,
                  this._selectedInstrument.positionMeans,
                  this._selectedInstrument.isAutoLine,
                  this._selectedInstrument.measurementId,
                  null,
                  this.state.sampleData?.testPlan ?? null
                );

                const instrumentDetails =
                  this.state.measurementDetails.instrumentDetails;
                if (this._selectedPosition === undefined) {
                  selectedInstrumentDetail.setMeasuredPosition(0);
                } else {
                  selectedInstrumentDetail.setMeasuredPosition(
                    this._selectedPosition
                  );
                }
                selectedInstrumentDetail.setCurrentMeasuringProperty(
                  this._currentMeasuringProperty,
                  this._currentMeasuringPosition
                );
                instrumentDetails[instrumentDetailIndex] =
                  selectedInstrumentDetail;

                this.setState(
                  {
                    selectedInstrumentDetail,
                    measurementDetails: {
                      ...this.state.measurementDetails,
                      instrumentDetails,
                    },
                  },
                  () => this.forceUpdate()
                );
              })
              .catch((errors) => console.log("errors", errors));
          }
        );
      })
      .catch((error) => console.log("error", error));
  };
  componentWillUnmount() {
    this._measurementConnection.stop().then(() => {
      console.log("Measurement Hub Stopped");
    });
    this._instrumentConnection.stop().then(() => {
      console.log("Instrument Hub Stopped");
    });
    this._sampleConnection.stop().then(() => {
      console.log("SAMPLE Hub Stopped");
    });
    this._exceptionConnection.stop().then(() => {
      console.log("EXECPTION Hub Stopped");
    });
    this._autolineConnection
      .stop()
      .then(() => console.log("STOPPED AUTOLINE HUB"));
  }

  /**
   * Function is used to toggle between to show either grid or table view
   */
  changeGridView = () => {
    this.setState({
      gridView: !this.state.gridView,
    });
  };

  /**
   * Function is used to  start measurement
   */
  private startMeasure = () => {
    if (!this.state.startLoading) {
      this.setState(
        {
          startLoading: true,
        },
        () => {
          measurementActions
            .startMeasurement(this.state.sampleData.id, uuidv4())
            .then(() => {
              if (this._goToMeasurement) {
                setTimeout(() => {
                  triggerNotifications.success(["Started Measurement"]);
                  this.props.statusChangeHandler({
                    id: "Measuring",
                    name: "Measuring",
                  });

                  if (this._measurementConnection.state === "Disconnected") {
                    this.measurementHubStart();
                  }
                  this.getInitialData(true);
                  this.setState({ startLoading: false })
                }, CONSTANTS.NOTIFICATION_TIMEOUT);
              }
            })
            .catch((error) => {
              triggerNotifications.errors(error.message, error.data).then();
              this.setState({ startLoading: false })
              return false;
            });
          return true;
        }
      );
    }
  };

  /**
   * Function is used to get sample details
   */
  private getInitialData(
    isConnection: boolean,
    fromUpdate?: boolean,
    selectedInstrumentId?: any
  ) {
    measurementActions
      .getSampleMeasurementDetails(this.state.sampleData.id)
      .then(() => {
        this.setState(
          {
            measurementDetails: this._measurementDetails,
          },
          () => {

            this.getAllInstrumentDetails(selectedInstrumentId);
            this.getAllKeyedInPropertyData();
            this.getSampleCalculatedDetailsApiCall();

            if (fromUpdate) {
              this.measurementHubStart();
            }
          }
        );
      })
      .catch((err) => console.log("err", err));
  }

  /** SINGLE INSTRUMENT DETAILS IN THE SAMPLE
   * Function is used to get a single (1) / selected  instrument details
   */
  public getSingleInstrumentDetails(selectedInstrumentId?: any) {
    // gets single instrument or selected instrument details

    measurementActions
      .getInstrumentMeasurementDetails(
        this.state.measurementDetails.id,
        this.state.measurementDetails.measurementId
      )
      .then(() => {
        const instrumentDetails: IInstrumentDetails[] = []; // instrumentDetails [] needed for getting the individual instrument details
        this._sampleInstrumentDetails.map((data: any) => {
          instrumentDetails.push(
            new InstrumentDetails(
              data.id,
              data.name,
              data.count,
              [],
              [],
              [],
              data.instrumentStatus,
              [],
              [],
              [],
              [],
              data.isAutoLine
            )
          );
        });
        this.setState(
          {
            sampleInstrumentDetails: this._sampleInstrumentDetails,
            measurementDetails: {
              ...this.state.measurementDetails,
              instrumentDetails,
            },
          },
          () => {
            let instrumentId: any;
            let selectedInstrument: any;
            if (selectedInstrumentId) {
              instrumentId = selectedInstrumentId;
              selectedInstrument = this.state.sampleInstrumentDetails.find(
                (x: any) => x.id === instrumentId
              );
            } else {
              instrumentId =
                this.state.measurementDetails.instrumentDetails[0].id;
              selectedInstrument = this.state.sampleInstrumentDetails.find(
                (x: any) => x.id === instrumentId
              );
            }
            measurementActions
              .getInstrumentDetails(
                this.state.measurementDetails.id,
                this.state.measurementDetails.measurementId,
                instrumentId
              )
              .then(() => {
                const instrumentDetailIndex =
                  this.state.measurementDetails.instrumentDetails.findIndex(
                    (x: any) => x.id === selectedInstrument.id
                  );
                console.log(instrumentDetailIndex);

                const instrumentIdArray: string[] =
                  this.state.measurementDetails.instrumentDetails.map(
                    (item: any) => {
                      return item.id;
                    }
                  );
                sampleActions
                  .checkinstrumentinuse(instrumentIdArray)
                  .then(() => {
                    console.log(this._checkInstrument);

                    // single instrument details selected
                    const selectedInstrumentDetail = new InstrumentDetails(
                      this._selectedInstrument.id,
                      this._selectedInstrument.name,
                      selectedInstrument.count,
                      this._selectedInstrument.directionCounts,
                      this._selectedInstrument.properties,
                      this._selectedInstrument.readings,
                      selectedInstrument.instrumentStatus,
                      this._selectedInstrument.positionCounts,
                      this._selectedInstrument.statistics,
                      this._selectedInstrument.propertyMeans,
                      this._selectedInstrument.positionMeans,
                      this._selectedInstrument.isAutoLine,
                      this._selectedInstrument.measurementId,
                      null,
                      this.state.sampleData?.testPlan ?? null,
                      this._checkInstrument[0]
                    ); // first one it selects

                    let instrumentDetails =
                      this.state.measurementDetails.instrumentDetails;
                    if (this._selectedPosition === undefined) {
                      selectedInstrumentDetail.setMeasuredPosition(0);
                    } else {
                      selectedInstrumentDetail.setMeasuredPosition(
                        this._selectedPosition
                      );
                    }
                    selectedInstrumentDetail.setCurrentMeasuringProperty(
                      this._currentMeasuringProperty,
                      this._currentMeasuringPosition
                    );
                    instrumentDetails[instrumentDetailIndex] =
                      selectedInstrumentDetail;

                    let selectedPosition = this.state.selectedPosition;
                    if (
                      selectedPosition &&
                      Object.keys(selectedPosition).length
                    ) {
                      selectedPosition =
                        selectedInstrumentDetail.countData.find(
                          (elements: any) =>
                            elements.position ===
                            this.state.selectedPosition.position
                        );
                    }

                    this.setState(
                      {
                        selectedInstrumentDetail,
                        measurementDetails: {
                          ...this.state.measurementDetails,
                          instrumentDetails,
                        },
                        selectedPosition,
                      },
                      () => this.forceUpdate()
                    );
                  })
                  .catch((errors) => console.log("errors", errors));
              });
          }
        );
        console.log("this");
      })
      .catch((error) => console.log("error", error));
  }

  /** ALL INSTRUMENT DETAILS IN THE SAMPLE
   * Function is used to fetch details of a single / a selected instrument details
   */
  public getAllInstrumentDetails(selectedInstrumentId?: any) {
    measurementActions
      .getInstrumentMeasurementDetails(
        this.state.measurementDetails.id,
        this.state.measurementDetails.measurementId
      ) // get all instrument values api call (sampleInstrumentDetails)
      .then(() => {
        const instrumentDetails: IInstrumentDetails[] = []; // instrumentDetails [] needed for getting the individual instrument details
        this._sampleInstrumentDetails.map((data: any) => {
          instrumentDetails.push(
            new InstrumentDetails(
              data.id,
              data.name,
              data.count,
              [],
              [],
              [],
              data.instrumentStatus,
              [],
              [],
              [],
              [],
              data.isAutoLine
            )
          );
        });
        const ids: any[] = [];
        this._sampleInstrumentDetails.map((instrument: any) => {
          ids.push(instrument.id);
        });

        if (this._instrumentConnection.state === "Disconnected") {
          this.instrumentHubStart(ids);
        }
        console.log(this._sampleConnection.state);
        if (this._sampleConnection.state === "Disconnected") {
          this.sampleHubStart();
        }
        this.setState(
          {
            sampleInstrumentDetails: this._sampleInstrumentDetails,
            measurementDetails: {
              ...this.state.measurementDetails,
              instrumentDetails,
            },
          },
          () => {
            this.state.measurementDetails.instrumentDetails.map(
              (instrument: any) => {
                measurementActions
                  .getInstrumentDetails(
                    this.state.measurementDetails.id, // get 1 instrument values api call
                    this.state.measurementDetails.measurementId,
                    instrument.id
                  )
                  .then(() => {
                    let selectedInstrument: any;
                    let instrumentDetailIndex: any;
                    let selectedInstrumentDetail: any;

                    selectedInstrument =
                      this.state.sampleInstrumentDetails.find(
                        (x: any) => x.id === this._selectedInstrument.id
                      );
                    instrumentDetailIndex =
                      this.state.measurementDetails.instrumentDetails.findIndex(
                        (x: any) => x.id === this._selectedInstrument.id
                      );

                    // single instrument details
                    selectedInstrumentDetail = new InstrumentDetails(
                      this._selectedInstrument.id,
                      this._selectedInstrument.name,
                      selectedInstrument.count,
                      this._selectedInstrument.directionCounts,
                      this._selectedInstrument.properties,
                      this._selectedInstrument.readings,
                      selectedInstrument.instrumentStatus,
                      this._selectedInstrument.positionCounts,
                      this._selectedInstrument.statistics,
                      this._selectedInstrument.propertyMeans,
                      this._selectedInstrument.positionMeans,
                      this._selectedInstrument.isAutoLine,
                      this._selectedInstrument.measurementId,
                      null,
                      this.state.sampleData?.testPlan ?? null,
                      this._checkInstrument[0]
                    );

                    let instrumentDetails =
                      this.state.measurementDetails.instrumentDetails;
                    if (this._selectedPosition === undefined) {
                      selectedInstrumentDetail.setMeasuredPosition(0);
                    } else {
                      selectedInstrumentDetail.setMeasuredPosition(
                        this._selectedPosition
                      );
                    }
                    selectedInstrumentDetail.setCurrentMeasuringProperty(
                      this._currentMeasuringProperty,
                      this._currentMeasuringPosition
                    );
                    instrumentDetails[instrumentDetailIndex] =
                      selectedInstrumentDetail;

                    let selectedPosition = this.state.selectedPosition;

                    if (
                      !this._selectedInstrument.isAutoLine &&
                      selectedInstrumentDetail &&
                      selectedInstrumentDetail.nextMeasuringPositionDireaction &&
                      selectedInstrumentDetail.nextMeasuringPositionDireaction
                        .position > -1
                    ) {
                      selectedPosition =
                        selectedInstrumentDetail.countData.find(
                          (elements: any) =>
                            elements.position ===
                            selectedInstrumentDetail
                              .nextMeasuringPositionDireaction.position
                        );
                    }

                    if (selectedInstrumentId === this._selectedInstrument.id) {
                      // stop, remeasure, pause to stay in the particular instrumentdetails page
                      this.setState(
                        {
                          selectedInstrumentDetail,
                          measurementDetails: {
                            ...this.state.measurementDetails,
                            instrumentDetails,
                          },
                          selectedPosition,
                        },
                        () => this.forceUpdate()
                      );
                    } else {
                      this.setState(
                        {
                          measurementDetails: {
                            ...this.state.measurementDetails,
                            instrumentDetails,
                          },
                          selectedPosition,
                        },
                        () => this.forceUpdate()
                      );
                    }
                  });
              }
            );
          }
        );
      })
      .catch((error) => console.log("error", error));
  }

  /** SINGLE KEYEDIN DETAILS IN THE SAMPLE
   * Function is used to get a single (1) / selected  keyed in details
   */
  private getKeyedInPropertyData = () => {
    measurementActions
      .getSampleKeyedInDetails(
        this.state.sampleData.id,
        this.state.measurementDetails.measurementId
      )
      .then(() => {
        if (this._mount) {
          if (this._keyedInData.length > 0) {
            this.setState(
              {
                keyedInSampleData: this._keyedInData,
              },
              () => {
                const selectedKeyedIn = this.state.keyedInSampleData[0];
                measurementActions
                  .getKeyedInDetails(
                    this.state.measurementDetails.id,
                    this.state.measurementDetails.measurementId,
                    selectedKeyedIn.id
                  )
                  .then(() => {
                    const keyedInDetail: IKeyedInDetails[] = [];
                    this.state.keyedInSampleData.map((selectedKeyedIn: any) => {
                      keyedInDetail.push(
                        new KeyedInDetails(
                          selectedKeyedIn.id,
                          selectedKeyedIn.name,
                          [selectedKeyedIn.count],
                          this._keyedInDetails.directionCounts,
                          selectedKeyedIn.status,
                          this._keyedInDetails.positionCounts,
                          selectedKeyedIn.unit,
                          this._keyedInDetails.readings,
                          this._keyedInDetails.propertyMean,
                          this._keyedInDetails.positionMeans,
                          this._keyedInDetails.statistics,
                          selectedKeyedIn.decimals
                        )
                      );
                    });
                    const keyedInDetailsData = new KeyedInDetailsData(
                      selectedKeyedIn.id,
                      selectedKeyedIn.name,
                      "",
                      true,
                      this.state.measurementDetails.measurementId,
                      "",
                      "",
                      keyedInDetail
                    );
                    this.setState(
                      {
                        keyedInDetailsData,
                      },
                      () => {
                        console.log(this.state.keyedInDetailsData);
                      }
                    );
                  })
                  .catch((err) => console.log(err));
              }
            );
          } else {
          }
        }
      })
      .catch((error) => console.log("error :>> ", error));
  };

  /** ALL KEYEDIN DETAILS IN THE SAMPLE
   * Function is used to fetch details of a single / a selected instrument details
   */
  private getAllKeyedInPropertyData = () => {
    // STATE FROM keyedInSampleData => keyedInDetailsData
    measurementActions
      .getSampleKeyedInDetails(
        this.state.sampleData.id, // get all keyedin values api call (SampleKeyedInDetails)
        this.state.measurementDetails.measurementId
      )
      .then(() => {
        if (this._mount) {
          if (this._keyedInData.length > 0) {
            this.setState(
              {
                keyedInSampleData: this._keyedInData,
              },
              () => {
                const keyedInDetailsDataArray: any = [];

                this.state.keyedInSampleData.map(
                  (keyedIn: any, index: number) => {
                    measurementActions
                      .getKeyedInDetails(
                        this.state.measurementDetails.id, // get 1 keyedin values api call
                        this.state.measurementDetails.measurementId,
                        keyedIn.id
                      )
                      .then(() => {
                        // Selected keyedin
                        let selectedKeyedIn = this.state.keyedInSampleData.find(
                          (x: any) => x.id === this._keyedInDetails.id
                        );
                        const keyedInDetail = [
                          new KeyedInDetails(
                            selectedKeyedIn.id,
                            selectedKeyedIn.name,
                            [selectedKeyedIn.count],
                            this._keyedInDetails.directionCounts,
                            selectedKeyedIn.status,
                            this._keyedInDetails.positionCounts,
                            selectedKeyedIn.unit,
                            this._keyedInDetails.readings,
                            this._keyedInDetails.propertyMean,
                            this._keyedInDetails.positionMeans,
                            this._keyedInDetails.statistics,
                            selectedKeyedIn.decimals
                          ),
                        ];
                        const keyedInDetailsData = new KeyedInDetailsData(
                          selectedKeyedIn.id,
                          selectedKeyedIn.name,
                          "",
                          true,
                          this.state.measurementDetails.measurementId,
                          "",
                          "",
                          keyedInDetail
                        );

                        keyedInDetailsDataArray[index] = keyedInDetailsData;

                        this.setState({
                          keyedInDetailsData: keyedInDetailsDataArray,
                        });
                      })
                      .catch((err) => console.log(err));
                  }
                );
              }
            );
          } else {
          }
        }
      })
      .catch((error) => console.log("error :>> ", error));
  };

  /**
   * Function is used to toggle the instrument property UI component
   */
  private showInstrumentPropertyComponent = (instrument?: any) => {
    const selectedInstrumentDetail =
      this.state.measurementDetails.instrumentDetails.find(
        (x: any) => x.id === instrument.id
      );
    this._currentInstrumentId = selectedInstrumentDetail
      ? selectedInstrumentDetail.id
      : "";

    this.setState({
      activeTab: [0],
      selectedInstrumentDetail: selectedInstrumentDetail,
      isInstrumentProperty: !this.state.isInstrumentProperty,
    });
  };

  /**
   * Function is used to toggle the instrument property value UI component
   */
  private showInstrumentPropertyDetailsComponent = (position?: any) => {
    this.setState({
      selectedPosition: position,
      isInstrumentPropertyDetails: !this.state.isInstrumentPropertyDetails,
    });
  };

  /**
   * Function is used to toggle keyedin property UI
   */
  showKeyedInPropertyComponent = (keyedIn?: any) => {
    const selectedKeyedInDetails = _.isEmpty(keyedIn)
      ? defaultKeyedInDetails
      : this.state.keyedInDetailsData.find((x: any) => x.id === keyedIn.id)
        .keyedInDetails[0];

    if (_.isEmpty(keyedIn)) {
      this.getAllKeyedInPropertyData();
      this.getSampleCalculatedDetailsApiCall();
    }
    this.setState({
      activeTab: [1],
      lastEnteredValue: this._lastKeyedInDetails,
      selectedKeyedInDetails: selectedKeyedInDetails,
      isKeyedInProperty: !this.state.isKeyedInProperty,
    });
  };

  /**
   * Function is used to toggle keyedin property UI in edit mode
   */
  showKeyedInPropertyDetailsComponent = (position?: any) => {
    this.setState({
      isKeyedInPropertyDetails: !this.state.isKeyedInPropertyDetails,
    });
  };

  /**
   * Function is used to toggle calculated property
   */
  showCalculatedPropertyDetailsComponent = (calculated?: any) => {
    if (_.isEmpty(calculated)) {
      this.setState({
        activeTab: [2],
        isCalculatedPropertyDetails: !this.state.isCalculatedPropertyDetails,
      });
    } else {
      if (this.state.calculatedDetailsData[0]?.calculatedValues?.length) {
        const selectedCalculatedDetails: any =
          this.state.calculatedDetailsData.find(
            (x: any) => x.id === calculated.id
          );
        this.setState({
          activeTab: [2],
          selectedCalculatedDetails: selectedCalculatedDetails,
          isCalculatedPropertyDetails: !this.state.isCalculatedPropertyDetails,
        });
      }
    }
  };

  // ====================================================================================================================================

  // ==========================================================================================

  private measurementPause = () => {
    this.setState({
      showPauseDialog: true,
    });
  };

  private onMeasurementPauseOkClick = () => {
    // STATUS TO PAUSE
    const measurementId =
      this.state.measurementDetails.measurementId === null ||
        this.state.measurementDetails.measurementId === undefined
        ? this.state.keyedInDetailsData.measurementId
        : this.state.measurementDetails.measurementId;
    if (!this.state.pauseLoading) {
      this.setState(
        {
          pauseLoading: true,
        },
        () => {
          measurementActions
            .pauseMeasurement(this.state.sampleData.id, measurementId, uuidv4())
            .then(() => {
              this._measurementConnection
                .stop()
                .then()
                .catch(() => {
                  console.log("Measurement Hub Stopped");
                });
              this._instrumentConnection
                .stop()
                .then()
                .catch(() => {
                  console.log("Instrument Hub Stopped");
                });
              const status = {
                id: "b5f609b7-c3fc-42ca-bc46-767c22b09ea0",
                name: "Paused",
              };
              this.props.statusChangeHandler(status);
              this.setState({
                showPauseDialog: false,
                isPaused: true,
                stopMeasurement: false,
                startMeasurement: false,
                pauseLoading: false,
                toastMsg: CONSTANTS.SAMPLE_PAUSED_MESSAGE,
                showToast: false,
              });
              setTimeout(() => {
                triggerNotifications.success([CONSTANTS.SAMPLE_PAUSED_MESSAGE]);
                this.setState({ showToast: false });
              }, CONSTANTS.NOTIFICATION_TIMEOUT);
            })
            .catch((error) => {
              this.setState(
                {
                  showPauseDialog: false,
                  pauseLoading: false,
                },
                () =>
                  triggerNotifications.errors(error.message, error.data).then()
              );
            });
        }
      );
    }
  };
  private measurementStop = () => {
    this.setState({
      showStopDialog: true,
    });
  };

  private onMeasurementStopOkClick = () => {
    // STATUS TO STOPPED
    const measurementId =
      this.state.measurementDetails.measurementId === null ||
        this.state.measurementDetails.measurementId === undefined
        ? this.state.keyedInDetailsData.measurementId
        : this.state.measurementDetails.measurementId;
    if (!this.state.stopLoading) {
      this.setState(
        {
          stopLoading: true,
        },
        () => {
          measurementActions
            .stopMeasurement(this.state.sampleData.id, measurementId, uuidv4())
            .then(() => {
              this._measurementConnection
                .stop()
                .then()
                .catch(() => {
                  console.log("Measurement Hub Stopped");
                });
              this._instrumentConnection
                .stop()
                .then()
                .catch(() => {
                  console.log("Instrument Hub Stopped");
                });
              const status = {
                id: "981bc4f5-a6b2-4916-8da5-f24739376ebd",
                name: "Stopped",
              };
              this.props.statusChangeHandler(status);
              this.setState({
                showStopDialog: false,
                stopMeasurement: this._stopMeasurement,
                startMeasurement: false,
                isPaused: false,
                isComplete: false,
                stopLoading: false,
                toastMsg: CONSTANTS.SAMPLE_STOPPED_MESSAGE,
                showToast: false,
              });
              setTimeout(() => {
                triggerNotifications.success([
                  CONSTANTS.SAMPLE_STOPPED_MESSAGE,
                ]);
                this.setState({ showToast: false });
              }, CONSTANTS.NOTIFICATION_TIMEOUT);
            })
            .catch((error) => {
              this.setState(
                {
                  showStopDialog: false,
                  stopLoading: false,
                },
                () =>
                  triggerNotifications.errors(error.message, error.data).then()
              );
            });
        }
      );
    }
  };

  // public resumeSampleMeasurement = () => {
  public resumeMeasurement = () => {
    if (!this.state.resumeLoading) {
      this.setState(
        {
          resumeLoading: true,
        },
        () => {
          // STATUS TO MEASURING
          measurementActions
            .resumeMeasurement(
              this.state.sampleData.id,
              this.state.measurementDetails.measurementId,
              uuidv4()
            )
            .then(() => {
              this.measurementHubStart();
              const status = {
                id: "63242767-d573-4295-bc36-64cb1ddc0afd",
                name: "Measuring",
              };
              this.props.statusChangeHandler(status);
              this.setState({
                startMeasurement: true,
                stopMeasurement: false,
                isPaused: false,
                resumeLoading: false,
              }, () => {
                this.getInitialData(true);
              });
            })
            .catch((error) => {
              triggerNotifications.errors(error.message, error.data).then();
              this.setState({ resumeLoading: false })
            });
        }
      )
    }
  };

  private reMeasure = (e: any, isSetActive: boolean) => {
    this.setState({
      showRemeasureDialog: true,
      shadowIsSetActive: isSetActive,
    });
  };

  private reMeasureCancelClick = () => {
    this.setState({
      showRemeasureDialog: false,
      isSetActive: !this.state.shadowIsSetActive,
    });
  };

  private onRemeasureOkClick = () => {
    // STATUS TO MEASURING
    const measurementId =
      this.state.measurementDetails.measurementId === null ||
        this.state.measurementDetails.measurementId === undefined
        ? this.state.keyedInDetailsData.measurementId
        : this.state.measurementDetails.measurementId;
    if (!this.state.remeasureLoading) {
      this.setState(
        {
          remeasureLoading: true,
          isSetActive: this.state.shadowIsSetActive,
        },
        () => {
          measurementActions
            .reMeasureMeasurement(this.state.sampleData.id, uuidv4(), this.state.isSetActive)
            .then(() => {
              const status = {
                id: "63242767-d573-4295-bc36-64cb1ddc0afd",
                name: "Measuring",
              };
              this.props.statusChangeHandler(status);

              let tempIndex: number;
              if (this.state.selectedKeyedInDetails.id) {
                tempIndex = this._lastKeyedInDetails.findIndex(
                  (x: any) =>
                    x.keyedInPropertyId === this.state.keyedInDetailsData[0].id
                );
              } else {
                tempIndex = this._lastKeyedInDetails.findIndex(
                  (x: any) =>
                    x.keyedInPropertyId === this.state.keyedInDetailsData[0].id
                );
              }

              this._lastKeyedInDetails = this._lastKeyedInDetails.slice(
                1,
                tempIndex
              );

              this.setState(
                {
                  lastEnteredValue: this._lastKeyedInDetails,
                  startMeasurement: true,
                  stopMeasurement: false,
                  isPaused: false,
                  showRemeasureDialog: false,
                  remeasureLoading: false,
                  isKeyedInProperty: false,
                  isKeyedInPropertyDetails: false,
                },
                () => {
                  this.measurementHubStart();

                  this.getInitialData(
                    true,
                    false,
                    this.state.selectedInstrumentDetail?.id
                  );
                }
              );
            })
            .catch((error: any) => {
              this.setState(
                {
                  showRemeasureDialog: false,
                  remeasureLoading: false,
                },
                () =>
                  triggerNotifications.errors(error.message, error.data).then()
              );
            });
        }
      );
    }
  };

  public completeMeasurement = () => {
    if (!this.state.completeLoading) {
      this.setState(
        {
          completeLoading: true,
        },
        () => {
          measurementActions
            .completeMeasurement(
              this.state.sampleData.id,
              this.state.sampleData.measurement ||
              this.state.measurementDetails.measurementId ||
              this.state.keyedInDetailsData.measurementId,
              uuidv4()
            )
            .then(() => {
              const status = {
                id: "68005087-9871-4b0a-8b00-c2e4e4e67856",
                name: "Measured",
              };
              this.props.statusChangeHandler(status);
              this.setState({
                isInstrumentPropertyDetails: false,
                isInstrumentProperty: false,
                isKeyedInProperty: false,
                isKeyedInPropertyDetails: false,
                completeLoading: false,
                isSetActive: false
              });
            })
            .catch((error) => {
              triggerNotifications.errors(error.message, error.data).then();
              this.setState({ completeLoading: false })
            });
        }
      );
    }
  };

  private measurementApprove = () => {
    if (!this.state.approveLoading) {
      this.setState(
        {
          approveLoading: true,
          isSetActive: false
        },
        () => {
          measurementActions
            .approveSampleMeasurement(
              this.state.sampleData.id,
              this.state.measurementDetails.measurementId ||
              this.state.sampleData.measurement ||
              this.state.keyedInDetailsData[0]?.measurementId,
              uuidv4()
            )
            .then((res) => {
              const status = {
                id: "805be14e-c6f7-47cd-b756-fcec1defaf7a",
                name: "Approved",
              };
              this.props.statusChangeHandler(status);
              this.setState({
                toastMsg: CONSTANTS.SAMPLE_APPROVED_MESSAGE,
                showToast: false,
              });
              setTimeout(() => {
                triggerNotifications.success([CONSTANTS.SAMPLE_APPROVED_MESSAGE]);
                this.setState({ showToast: false, approveLoading: false });
              }, CONSTANTS.NOTIFICATION_TIMEOUT);
            })
            .catch((error) => {
              triggerNotifications.errors(error.message, error.data).then();
              this.setState({ approveLoading: false })
            });
        }
      );
    }
  };

  private measurementReject = () => {
    if (!this.state.rejectLoading) {
      this.setState(
        {
          rejectLoading: true,
          isSetActive: false
        },
        () => {
          measurementActions
            .rejectSampleMeasurement(
              this.state.sampleData.id,
              this.state.measurementDetails.measurementId ||
              this.state.sampleData.measurement ||
              this.state.keyedInDetailsData[0]?.measurementId,
              uuidv4()
            )
            .then((res) => {
              const status = {
                id: "7fe90471-5936-41ee-8473-107538e40c40",
                name: "Rejected",
              };
              this.props.statusChangeHandler(status);
              this.setState({
                toastMsg: CONSTANTS.SAMPLE_REJECTED_MESSAGE,
                showToast: false,
              });
              setTimeout(() => {
                triggerNotifications.success([CONSTANTS.SAMPLE_REJECTED_MESSAGE]);
                this.setState({ showToast: false, rejectLoading: false });
              }, CONSTANTS.NOTIFICATION_TIMEOUT);
            })
            .catch((error) => {
              triggerNotifications.errors(error.message, error.data).then();
              this.setState({ rejectLoading: false })
            });
        }
      );
    }
  };

  // instrument actions

  //=========== START INSTRUMENT
  private startInstrumentMeasurement = (event: any, instrumentId: string) => {
    measurementActions
      .startInstrumentMeasurement(
        this.state.sampleData.id,
        this.state.measurementDetails.measurementId,
        instrumentId,
        uuidv4()
      )
      .then()
      .catch((error) => {
        triggerNotifications.errors(error.message, error.data).then();
      });
    event.stopPropagation();
  };

  // =========== STOP INSTRUMENT
  private stopInstrumentMeasurement = (event: any, instrumentId: string) => {
    this._currentInstrumentId = instrumentId;
    this.setState({
      showInstrumentStopDialog: true,
    });
    event.stopPropagation();
  };

  private stopAfterConfirm = () => {
    measurementActions
      .stopInstrumentMeasurement(
        this.state.sampleData.id,
        this.state.measurementDetails.measurementId,
        this._currentInstrumentId,
        uuidv4()
      )
      .then(() =>
        this.setState({
          showInstrumentStopDialog: false,
        })
      )
      .catch((error) => {
        this.setState(
          {
            showInstrumentStopDialog: false,
          },
          () => triggerNotifications.errors(error.message, error.data).then()
        );
      });
  };

  //=========== REMEASURE INSTRUMENT
  private remeasureInstrumentMeasurement = (
    event: any,
    instrumentId: string
  ) => {
    this._currentInstrumentId = instrumentId;
    this.setState({
      showInstrumentRemeasureDialog: true,
    });
    event.stopPropagation();
  };

  private remeasureAfterConfirmation = () => {
    measurementActions
      .remeasureInstrumentMeasurement(
        this.state.sampleData.id,
        this.state.measurementDetails.measurementId,
        this._currentInstrumentId,
        uuidv4()
      )

      .then(() => {
        this.setState(
          {
            showInstrumentRemeasureDialog: false,
            selectedPositionFromMeasuring: null,
          },
          () => {
            this.getAllInstrumentDetails(this._currentInstrumentId);
          }
        );
      })
      .catch((error) => {
        this.setState(
          {
            showInstrumentRemeasureDialog: false,
          },
          () => triggerNotifications.errors(error.message, error.data).then()
        );
      });
  };

  public onRemeasureClick = () => {
    this.getDefaultInstrumentdata(this._currentInstrumentId);
  }

  //=========== RESUME INSTRUMENT
  private resumeInstrumentMeasurement = (event: any, instrumentId: string) => {
    measurementActions
      .resumeInstrumentMeasurement(
        this.state.sampleData.id,
        this.state.measurementDetails.measurementId,
        instrumentId,
        uuidv4()
      )
      .then()
      .catch((error) => {
        triggerNotifications.errors(error.message, error.data).then();
      });
    event.stopPropagation();
  };

  // ====================================================================================================================================

  private onExportCall = () => {
    if (this._onExportCall) {
      this._onExportCall = false;
      setTimeout(() => {
        this.setState(
          {
            isExportShow: !this.state.isExportShow,
          },
          () => {
            this._onExportCall = true;
          }
        );
      }, 300);
    }
  };
  private onExportDataClick = () => {
    this.setState({ isExportShow: false })
    sampleActions
      .exportAll(this.props.activeItem.id, [this.props.activeItem.id], 2, uuidv4(), null)
      .then(() => {
        triggerNotifications.success(["Measurement exported"]).then();
        this.setState({
          isExportShow: false,
        });
      })
      .catch((messages) => {
        triggerNotifications.errors(messages);
      });
  };
  private onExportXLSDataClick = () => {
    sampleActions
      .exportWithMeasurementXLS([this.props.activeItem.id], uuidv4())
      .then(() => {
        triggerNotifications.success(["Measurement exported"]).then();
        this.setState({
          isExportShow: false,
        });
      })
      .catch((messages) => {
        triggerNotifications.errors(messages);
      });
  };

  private onExportClick = () => {
    this.setState({ isExportShow: false })
    sampleActions
      .exportAll(this.props.activeItem.id, [this.props.activeItem.id], 1, uuidv4(), null)
      .then(() => {
        triggerNotifications.success(["Sample exported"]).then();
        this.setState({
          isExportShow: false,
        });
      })
      .catch((messages) => {
        triggerNotifications.errors(messages);
      });
  };

  private onReportClick = () => {
    if (this._onReportClick) {
      this._onReportClick = false;
      setTimeout(() => {
        this.setState(
          {
            isReportDropdownShow: !this.state.isReportDropdownShow,
          },
          () => {
            this._onReportClick = true;
          }
        );
      }, 300);
    }
  };

  private onMenuNarrow = () => {
    this.setState({
      isMenuNarrow: !this.state.isMenuNarrow,
    });
  };

  private onEditCall = () => {
    if (this._onEditCall) {
      this._onEditCall = false;
      setTimeout(() => {
        this.setState(
          {
            isEditShow: !this.state.isEditShow,
          },
          () => {
            this._onEditCall = true;
          }
        );
      }, 300);
    }
  };
  // =============================================================================

  private onReportLinkClick = (reportType: string) => {
    this.setState({ isReportDropdownShow: false })
    window.open(
      `${CONSTANTS.SAMPLENEW_REPORT}/${reportType}/${this.props.activeItem.id}`,
      "_blank"
    );
  };

  private onEditClick = () => {
    History.push(CONSTANTS.SAMPLE_CREATE_URL_NEW, this.state.editData);
  };

  private openDeleteDialog = () => {
    this.setState({ deleteModalVisible: true });
  };
  private onDeleteClick = () => {
    sampleActions
      .delete(this.state.deleteId, this.state.deleteRequesId)
      .then(() => {
        triggerNotifications.success([CONSTANTS.SAMPLE_DELETED_MESSAGE]);
        this.setState(
          {
            toastMsg: CONSTANTS.SAMPLE_DELETED_MESSAGE,
            showToast: false,
          },
          () => {
            this.setState({
              showToast: false,
            });
            setTimeout(() => {
              this.onMenuNarrow();
              this.props.onDelete(this.state.deleteId);
            }, 2000);
          }
        );
      })
      .catch((error) => {
        triggerNotifications.errors(error.message, error.data);
      });
    this.setState({ deleteModalVisible: false });
  };

  private getSingleInstrumentRemeasurementDetails(selectedInstrumentId?: any) {
    // gets single instrument or selected instrument details

    measurementActions
      .getInstrumentMeasurementDetails(
        this.state.measurementDetails.id,
        this.state.measurementDetails.measurementId
      )
      .then(() => {
        const instrumentDetails: IInstrumentDetails[] = []; // instrumentDetails [] needed for getting
        const findInstrumentDetails = (
          this._sampleInstrumentDetails || []
        ).find((x: any) => x.id === selectedInstrumentId);
        (this.state.measurementDetails.instrumentDetails || []).forEach(
          (x: any) => {
            if (x.id === selectedInstrumentId) {
              if (findInstrumentDetails) {
                instrumentDetails.push(
                  new InstrumentDetails(
                    findInstrumentDetails.id,
                    findInstrumentDetails.name,
                    findInstrumentDetails.count,
                    [],
                    [],
                    [],
                    findInstrumentDetails.instrumentStatus,
                    [],
                    [],
                    [],
                    [],
                    findInstrumentDetails.isAutoLine
                  )
                );
              }
            } else {
              instrumentDetails.push(x);
            }
          }
        );
        this.setState(
          {
            sampleInstrumentDetails: this._sampleInstrumentDetails,
            measurementDetails: {
              ...this.state.measurementDetails,
              instrumentDetails,
            },
          },
          () => {
            let instrumentId: any;
            let selectedInstrument: any;
            if (selectedInstrumentId) {
              instrumentId = selectedInstrumentId;
              selectedInstrument = this.state.sampleInstrumentDetails.find(
                (x: any) => x.id === instrumentId
              );
            } else {
              instrumentId =
                this.state.measurementDetails.instrumentDetails[0].id;
              selectedInstrument = this.state.sampleInstrumentDetails.find(
                (x: any) => x.id === instrumentId
              );
            }
            measurementActions
              .getInstrumentDetails(
                this.state.measurementDetails.id,
                this.state.measurementDetails.measurementId,
                instrumentId
              )
              .then(() => {
                const instrumentDetailIndex =
                  this.state.measurementDetails.instrumentDetails.findIndex(
                    (x: any) => x.id === selectedInstrument.id
                  );
                console.log(instrumentDetailIndex);

                const instrumentIdArray: string[] =
                  this.state.measurementDetails.instrumentDetails.map(
                    (item: any) => {
                      return item.id;
                    }
                  );
                sampleActions
                  .checkinstrumentinuse(instrumentIdArray)
                  .then(() => {
                    console.log(this._checkInstrument);

                    // single instrument details selected
                    const selectedInstrumentDetail = new InstrumentDetails(
                      this._selectedInstrument.id,
                      this._selectedInstrument.name,
                      selectedInstrument.count,
                      this._selectedInstrument.directionCounts,
                      this._selectedInstrument.properties,
                      this._selectedInstrument.readings,
                      selectedInstrument.instrumentStatus,
                      this._selectedInstrument.positionCounts,
                      this._selectedInstrument.statistics,
                      this._selectedInstrument.propertyMeans,
                      this._selectedInstrument.positionMeans,
                      this._selectedInstrument.isAutoLine,
                      this._selectedInstrument.measurementId,
                      null,
                      this.state.sampleData?.testPlan ?? null,
                      this._checkInstrument[0]
                    ); // first one it selects

                    let instrumentDetails =
                      this.state.measurementDetails.instrumentDetails;
                    if (this._selectedPosition === undefined) {
                      selectedInstrumentDetail.setMeasuredPosition(0);
                    } else {
                      selectedInstrumentDetail.setMeasuredPosition(
                        this._selectedPosition
                      );
                    }
                    selectedInstrumentDetail.setCurrentMeasuringProperty(
                      this._currentMeasuringProperty,
                      this._currentMeasuringPosition
                    );
                    instrumentDetails[instrumentDetailIndex] =
                      selectedInstrumentDetail;

                    let selectedPosition = this.state.selectedPosition;
                    if (
                      selectedPosition &&
                      Object.keys(selectedPosition).length
                    ) {
                      selectedPosition =
                        selectedInstrumentDetail.countData.find(
                          (elements: any) =>
                            elements.position ===
                            this.state.selectedPosition.position
                        );
                    }

                    this.setState(
                      {
                        selectedInstrumentDetail,
                        measurementDetails: {
                          ...this.state.measurementDetails,
                          instrumentDetails,
                        },
                        selectedPosition,
                      },
                      () => this.forceUpdate()
                    );
                  })
                  .catch((errors) => console.log("errors", errors));
              });
          }
        );
        console.log("this");
      })
      .catch((error) => console.log("error", error));
  }

  private reMeasureDirectionPositionCount = (
    instumentId: string,
    directionId: string,
    position: number,
    count: number,
    isFromPositions: boolean = false
  ) => {
    if (isFromPositions) {
      sampleActions
        .reMeasureLastMeasurementAll(
          this.props.sampleData?.id ?? "",
          instumentId,
          [directionId],
          this.state.measurementDetails?.measurementId ?? "",
          position,
          [count],
          this.state.isSetActive,
          () => {
            this.getSingleInstrumentRemeasurementDetails(instumentId);
          }
        )
        .then(() => {
          this._message = [i18next.t("Instrument remeasured")];
          triggerNotifications.success(this._message).then();
        })
        .catch((error) => {
          triggerNotifications.errors(error.message, error.data).then();
        });
    } else {
      sampleActions
        .reMeasureLastMeasurement(
          this.props.sampleData?.id ?? "",
          instumentId,
          directionId,
          this.state.measurementDetails?.measurementId ?? "",
          position,
          count,
          () => {
            this.getSingleInstrumentRemeasurementDetails(instumentId);
          }
        )
        .then(() => {
          this._message = [`${this.state.sampleId} ${i18next.t("remeasured")}`];
          triggerNotifications.success(this._message).then();
        })
        .catch((error) => {
          triggerNotifications.errors(error.message, error.data).then();
        });
    }
  };
  private reMeasureDirectionPositionCountAll = (
    instumentId: string,
    directionId: string[],
    position: any,
    count: number[]
  ) => {
    sampleActions
      .reMeasureLastMeasurementAll(
        this.props.sampleData?.id ?? "",
        instumentId,
        directionId,
        this.state.measurementDetails?.measurementId ?? "",
        position,
        count,
        this.state.isSetActive,
        () => {
          this.getSingleInstrumentRemeasurementDetails(instumentId);
        }
      )
      .then(() => {
        this._message = [i18next.t("Instrument remeasured")];
        triggerNotifications.success(this._message).then();
      })
      .catch((error) => {
        triggerNotifications.errors(error.message, error.data).then();
      });
  };

  private reMeasureDirectionPositionCountSingleAll = (
    instumentId: string,
    directionId: string,
    position: number,
    count: number,
    directionIddummy: string[],
    countdummy: number[]
  ) => {
    sampleActions
      .reMeasureLastMeasurementAll(
        this.props.sampleData?.id ?? "",
        instumentId,
        directionIddummy,
        this.state.measurementDetails?.measurementId ?? "",
        position,
        countdummy,
        this.state.isSetActive,
        () => {
          this.getSingleInstrumentRemeasurementDetails(instumentId);
        }
      )
      .then(() => {
        this._message = [i18next.t("Instrument remeasured")];
        triggerNotifications.success(this._message).then();
      })
      .catch((error) => {
        triggerNotifications.errors(error.message, error.data).then();
      });
  };

  private skipCountInPosition = (
    IntrumentId: string,
    Position: number,
    direction: string,
    count: number[]
  ) => {
    sampleActions
      .skipCountinPosition(
        this.props.sampleData?.id ?? "",
        IntrumentId,
        this.state.measurementDetails?.measurementId ?? "",
        Position,
        direction,
        count,
        this.state.isSetActive
      )
      .then(() => {
        this._message = [`position ${Position + 1} ${i18next.t("counts are skipped")}`];
        triggerNotifications.success(this._message).then();
        // this.getDefaultInstrumentdata(this._currentInstrumentId);
        const measurementDetails = { ...this.state.measurementDetails };
        const instrumentDetails = [...measurementDetails.instrumentDetails];
        const instrumentDetail = measurementDetails.instrumentDetails.find(
          (x: any) => x.id === IntrumentId
        );
        const instrumentDetailIndex =
          measurementDetails.instrumentDetails.findIndex(
            (x: any) => x.id === IntrumentId
          );
        instrumentDetail.countData = instrumentDetail.countData.map(
          (elements: any) => {
            if (elements.position === Position) {
              elements.directions = elements.directions.map((el: any) => {
                if (
                  IntrumentId &&
                  IntrumentId.length &&
                  (el.id === direction || el.name === "All")
                ) {
                  let skippedDetails = el.skippedDetails || [];
                  if (el.name !== "All")
                    count.forEach((x: number) => skippedDetails.push(x));
                  return {
                    ...el,
                    skipped: el.skipped
                      ? Number(el.skipped) + Number(count.length)
                      : count.length,
                    completedCounts: el.completedCounts
                      ? Number(el.completedCounts) + Number(count.length)
                      : count.length,
                    skippedDetails,
                  };
                } else {
                  return el;
                }
              });
              return elements;
            } else {
              return elements;
            }
          }
        );
        instrumentDetail.nextMeasuringPositionDireaction =
          instrumentDetail.getNextMeasuringDetails(
            instrumentDetail.countData,
            instrumentDetail.allDirections,
            this.state.sampleData.testPlan,
            instrumentDetail.readings
          );
        let completedCounts: number = 0;
        instrumentDetail.countData.forEach((elem: any) => {
          completedCounts += elem.directions[0]?.completedCounts ?? 0;
        });

        instrumentDetail.setCount({
          completedCounts,
          totalCounts: instrumentDetail.count.totalCounts,
        });
        const dir = instrumentDetail.allDirections.find((x: any) => {
          return (
            x.id ===
            instrumentDetail.nextMeasuringPositionDireaction?.directionId
          );
        });

        const dropdownlabel: any = {
          isNew: false,
          itemTemplate: undefined,
          label: dir.name,
          menuItemTemplate: undefined,
          selectedItemTemplate: undefined,
          value: dir.id,
        };

        instrumentDetails[instrumentDetailIndex] = instrumentDetail;
        this.setState({
          measurementDetails: {
            ...this.state.measurementDetails,
            instrumentDetails,
          },
          selectedDirection: [dropdownlabel],
        });
      })
      .catch((error) => {
        triggerNotifications.errors(error.message, error.data).then();
      });
  };

  private endPositionFunc = (IntrumentId: string, Position: number) => {
    const measurementDetails = { ...this.state.measurementDetails };
    const instrumentDetails = [...measurementDetails.instrumentDetails];
    const instrumentDetail = measurementDetails.instrumentDetails.find(
      (x: any) => x.id === IntrumentId
    );
    const instrumentDetailIndex =
      measurementDetails.instrumentDetails.findIndex(
        (x: any) => x.id === IntrumentId
      );

    let directionId = [];
    if (
      this.state.sampleData.testPlan &&
      this.state.sampleData.testPlan.isPDC
    ) {
      directionId = instrumentDetail.allDirections.map((el: any) => {
        return el.id;
      });
    } else {
      directionId = [
        this.state.selectedInstrumentDetail.nextMeasuringPositionDireaction
          ?.directionId,
      ];
    }

    sampleActions
      .endPosition(
        this.props.sampleData?.id ?? "",
        IntrumentId,
        this.state.measurementDetails?.measurementId ?? "",
        Position,
        directionId
      )
      .then(() => {
        this._message = [`position ${Position + 1} ${i18next.t("ended")}`];
        triggerNotifications.success(this._message).then();

        instrumentDetail.countData = instrumentDetail.countData.map(
          (elements: any) => {
            if (elements.position === Position) {
              if (
                this.state.sampleData.testPlan &&
                this.state.sampleData.testPlan.isPDC
              ) {
                elements.directions = elements.directions.map((el: any) => {
                  const skipped =
                    (el?.skipped ?? 0) + (el.totalCounts - el.completedCounts);

                  let findCount = (instrumentDetail.readings || [])
                    .filter(
                      (x: IReadings) =>
                        x.directionId === el.id &&
                        x.position === elements.position
                    )
                    .map((x: IReadings) => x.count);
                  let totalCount = Array.from(
                    { length: el.totalCounts },
                    (_, index) => index + 1
                  );
                  let uniqueDat = _.uniq(findCount) || [];
                  let diffData = _.difference(totalCount, uniqueDat);
                  return {
                    ...el,
                    skipped,
                    completedCounts: el.totalCounts,
                    skippedDetails: diffData,
                  };
                });
                return elements;
              } else {
                let totalSkipped: number = 0;
                let totalCompleted: number = 0;
                elements.directions = elements.directions
                  .reverse()
                  .map((el: any) => {
                    let skipped: number = el?.skipped ?? 0;
                    let completedCounts = el.completedCounts;
                    let skippedDetails = [];
                    if (
                      el.id ===
                      instrumentDetail.nextMeasuringPositionDireaction
                        .directionId
                    ) {
                      let findCount = (instrumentDetail.readings || [])
                        .filter(
                          (x: IReadings) =>
                            x.directionId === el.id &&
                            x.position === elements.position
                        )
                        .map((x: IReadings) => x.count);
                      let totalCount = Array.from(
                        { length: el.totalCounts },
                        (_, index) => index + 1
                      );
                      let uniqueDat = _.uniq(findCount) || [];
                      let diffData = _.difference(totalCount, uniqueDat);

                      skippedDetails = diffData;
                      skipped =
                        (el?.skipped ?? 0) +
                        (el.totalCounts - el.completedCounts);
                      completedCounts = el.totalCounts;
                      totalSkipped += skipped;
                      totalCompleted += el.totalCounts;
                    } else if (el.name === "All") {
                      skipped = totalSkipped;
                      completedCounts = totalCompleted;
                      skippedDetails = el.skippedDetails;
                    } else {
                      totalSkipped += el?.skipped ?? 0;
                      totalCompleted += el.completedCounts;
                      skippedDetails = el.skippedDetails;
                    }

                    return {
                      ...el,
                      skipped,
                      completedCounts,
                      skippedDetails,
                    };
                  });
                elements.directions.reverse();
                return elements;
              }
            } else {
              return elements;
            }
          }
        );

        instrumentDetail.nextMeasuringPositionDireaction =
          instrumentDetail.getNextMeasuringDetails(
            instrumentDetail.countData,
            instrumentDetail.allDirections,
            this.state.sampleData.testPlan
          );

        let NextPosition: any = null;
        if (instrumentDetail.nextMeasuringPositionDireaction.directionId) {
          NextPosition = instrumentDetail.countData.find(
            (elements: any) =>
              elements.position ===
              instrumentDetail.nextMeasuringPositionDireaction.position
          );
        }
        let completedCounts: number = 0;
        instrumentDetail.countData.forEach((elem: any) => {
          completedCounts += elem.directions[0]?.completedCounts ?? 0;
        });

        instrumentDetail.setCount({
          completedCounts,
          totalCounts: instrumentDetail.count.totalCounts,
        });

        instrumentDetails[instrumentDetailIndex] = instrumentDetail;

        const dir = instrumentDetail.allDirections.find((x: any) => {
          return (
            x.id ===
            instrumentDetail.nextMeasuringPositionDireaction?.directionId
          );
        });

        const dropdownlabel: any = {
          isNew: false,
          itemTemplate: undefined,
          label: dir.name,
          menuItemTemplate: undefined,
          selectedItemTemplate: undefined,
          value: dir.id,
        };

        this.setState({
          measurementDetails: {
            ...this.state.measurementDetails,
            instrumentDetails,
          },
          selectedPosition: NextPosition,
          isInstrumentPropertyDetails: NextPosition ? true : false,
          selectedDirection: [dropdownlabel],
        });
      })
      .catch((error) => {
        triggerNotifications.errors(error.message, error.data).then();
      });
  };

  private callApiOnTabChange = (tab: number) => {
    switch (tab) {
      case 1:
        this.getAllKeyedInPropertyData();
        break;
      case 2:
        this.getSampleCalculatedDetailsApiCall();
        break;
      default:
        break;
    }
  };

  public keyInCompletedHandeler = () => {
    if (this.state.keyedInCountFromHub[0]?.completedCounts &&
      this.state.keyedInCountFromHub[0]?.totalCounts &&
      this.state.keyedInCountFromHub[0].completedCounts === this.state.keyedInCountFromHub[0].totalCounts &&
      this.props.activeItem?.status?.name !== CONSTANTS.MEASURED) {
      this.showKeyedInPropertyComponent(this.state.selectedKeyedInDetails || "")
    }
  }

  private onToggle = (togglePosition: any[]) => {
    this.setState({
      activeTab: togglePosition
    });
    this.callApiOnTabChange(togglePosition[0] || 0);
  }

  render() {
    // make sure all required component's inputs/Props keys&types match
    const measurementLandingProps = {
      changeGridView: this.changeGridView,
      showInstrumentProperty: this.showInstrumentPropertyComponent,
      showKeyedInProperty: this.showKeyedInPropertyComponent,
      activeItem: this.props.activeItem,
      measurementDetails: this.state.measurementDetails,
      keyedInDetailsData: this.state.keyedInDetailsData,
      calculatedDetailsData: this.state.calculatedDetailsData,
    };

    const measurementTableProps = {
      activeTab: this.state.measurementDetails?.instrumentDetails?.length > 0 ? this.state.activeTab : (this.state.activeTab.includes(1) || this.state.activeTab.includes(2)) ? this.state.activeTab : [1],
      changeGridView: this.changeGridView,
      showInstrumentProperty: this.showInstrumentPropertyComponent,
      showKeyedInProperty: this.showKeyedInPropertyComponent,
      showCalculatedPropertyDetails:
        this.showCalculatedPropertyDetailsComponent,
      measurementDetails: this.state.measurementDetails,
      sampleData: this.props.sampleData,
      keyedInDetailsData: this.state.keyedInDetailsData,
      calculatedDetailsData: this.state.calculatedDetailsData,
      startInstrumentMeasurement: this.startInstrumentMeasurement,
      stopInstrumentMeasurement: this.stopInstrumentMeasurement,
      resumeInstrumentMeasurement: this.resumeInstrumentMeasurement,
      remeasureInstrumentMeasurement: this.remeasureInstrumentMeasurement,
      lastEnteredValue: this.state.lastEnteredValue,
      selectedPositionFromMeasuring: this.state.selectedPositionFromMeasuring,
      reMeasureDirectionPositionCount: this.reMeasureDirectionPositionCount,
      callApiOnTabChange: this.callApiOnTabChange,
      onToggle: this.onToggle
    };

    const instrumentPropertyProps = {
      details: false,
      showInstrumentProperty: this.showInstrumentPropertyComponent,
      showInstrumentPropertyDetails:
        this.showInstrumentPropertyDetailsComponent,
      selectedInstrumentDetail: this.state.selectedInstrumentDetail,
      selectedDirection: this.state.selectedDirection,
      thresholdSettings: this.state.thresholdSettings,
      startInstrumentMeasurement: this.startInstrumentMeasurement,
      stopInstrumentMeasurement: this.stopInstrumentMeasurement,
      resumeInstrumentMeasurement: this.resumeInstrumentMeasurement,
      remeasureInstrumentMeasurement: this.remeasureInstrumentMeasurement,
      sampleName: this.props.sampleData?.name ?? "",
      sampleStatus: this.props.sampleData?.status?.name ?? "",
    };

    const instrumentPropertyDetailsProps = {
      showInstrumentProperty: this.showInstrumentPropertyComponent,
      showInstrumentPropertyDetails:
        this.showInstrumentPropertyDetailsComponent,
      selectedInstrumentDetail: this.state.selectedInstrumentDetail,
      selectedDirection: this.state.selectedDirection,
      selectedPosition: this.state.selectedPosition,
      thresholdSettings: this.state.thresholdSettings,
      startInstrumentMeasurement: this.startInstrumentMeasurement,
      stopInstrumentMeasurement: this.stopInstrumentMeasurement,
      resumeInstrumentMeasurement: this.resumeInstrumentMeasurement,
      remeasureInstrumentMeasurement: this.remeasureInstrumentMeasurement,
      reMeasureDirectionPositionCount: this.reMeasureDirectionPositionCount,
      reMeasureDirectionPositionCountAll:
        this.reMeasureDirectionPositionCountAll,
      reMeasureDirectionPositionCountSingleAll:
        this.reMeasureDirectionPositionCountSingleAll,
      skipCountInPosition: this.skipCountInPosition,
      endPosition: this.endPositionFunc,
      testPlan: this.state.sampleData.testPlan,
      activeItem: this.props.activeItem,
      onRemeasureClick: this.onRemeasureClick,
    };

    const keyedInPropertyProps = {
      showKeyedInProperty: this.showKeyedInPropertyComponent,
      showKeyedInPropertyDetails: this.showKeyedInPropertyDetailsComponent,
      selectedKeyedInDetails: this.state.selectedKeyedInDetails,
      thresholdSettings: this.state.thresholdSettings,
      countValue: this.state.countValue,
      keyedInSampleData: this.state.keyedInSampleData,
      keyInCompletedHandeler: this.keyInCompletedHandeler,
      sampleDataDummy: this.state.sampleData.id,
      measurementIdDummy: this.state.keyedInDetailsData[0]?.measurementId ?? "",
    };

    const keyedInPropertyDetailsProps = {
      showKeyedInProperty: this.showKeyedInPropertyComponent,
      showKeyedInPropertyDetails: this.showKeyedInPropertyDetailsComponent,
    };

    const calculatedPropertyDetailsProps = {
      selectedCalculatedDetails: this.state.selectedCalculatedDetails,
      showCalculatedPropertyDetails:
        this.showCalculatedPropertyDetailsComponent,
      thresholdSettings: this.state.thresholdSettings,
    };

    const measurementOverviewProps = {
      activeItem: this.props.activeItem,
      activeMeasurementId: this.state.measurementDetails.measurementId,
      settingsData: this._settingsData,
      showToastMessage: this.props.showToastMessage
    };
    return (
      <Translation>
        {(t) => (
          <div
            ref={this.props.childRef}
            className={`row content-section ${this.props.sidebarCollapsed ? "expanded" : ""
              }`}
          >
            <div className="container-fluid py-2 px-0">
              <div className="row content-header px-0">
                <Toast
                  toasterMsg={this.state.toastMsg}
                  toggleToaster={this.state.showToast}
                />
                <div className="col-xl-5 col-lg-5 col-md-4">
                  <h4 className="d-flex">
                    {" "}
                    <span 
                    className="d-md-none d-lg-inlne-block d-xl-inline-block name-overflow" 
                    style={{ fontSize: "24px", margin: 0, maxWidth: this.props.activeItem?.name && this.props.activeItem.name.length > 20 ? '18vw' : 'auto'  }}>{this.props.activeItem?.name}</span>
                    <span className="d-md-none d-lg-inlne-block d-xl-inline-block">
                      {(this.props.activeItem?.status == null ||
                        this.props.activeItem?.status.name ===
                        Status.NOTMEASURED) && (
                          <React.Fragment>
                            <Icon
                              style={{ verticalAlign: "sub" }}
                              name="abb/warning-circle-2"
                              sizeClass="medium"
                            />
                            <span
                              className="ml-1 fs-20"
                              style={{ fontSize: "24px" }}
                            >
                              <b>{t(Status.PENDING)}</b>
                            </span>
                          </React.Fragment>
                        )}
                      {this.props.activeItem?.status?.name ===
                        Status.MEASURING && (
                          <React.Fragment>
                            <Icon
                              style={{ verticalAlign: "sub", color: "#3366FF" }}
                              name="abb/warning-circle-1"
                              sizeClass="medium"
                            />
                            <span
                              className="ml-1 fs-20"
                              style={{ fontSize: "24px" }}
                            >
                              <b>{t(Status.MEASURING)}</b>
                            </span>
                          </React.Fragment>
                        )}
                      {this.props.activeItem?.status?.name ===
                        Status.PAUSED && (
                          <React.Fragment>
                            <Icon
                              style={{ verticalAlign: "sub", color: "#3366FF" }}
                              name="abb/warning-circle-1"
                              sizeClass="medium"
                            />
                            <span
                              className="ml-1 fs-20"
                              style={{ fontSize: "24px" }}
                            >
                              <b>{t(Status.PAUSED)}</b>
                            </span>
                          </React.Fragment>
                        )}
                      {this.props.activeItem?.status?.name ===
                        Status.STOPPED && (
                          <React.Fragment>
                            <Icon
                              style={{ verticalAlign: "sub", color: "#3366FF" }}
                              name="abb/warning-circle-1"
                              sizeClass="medium"
                            />
                            <span
                              className="ml-1 fs-20"
                              style={{ fontSize: "24px" }}
                            >
                              <b>{t(Status.STOPPED)}</b>
                            </span>
                          </React.Fragment>
                        )}
                      {this.props.activeItem?.status?.name ===
                        Status.MEASURED && (
                          <React.Fragment>
                            <Icon
                              style={{ verticalAlign: "sub", color: "#000000" }}
                              name="abb/warning-circle-1"
                              sizeClass="medium"
                            />
                            <span
                              className="ml-1 fs-20"
                              style={{ fontSize: "24px" }}
                            >
                              <b>{t(Status.MEASURED)}</b>
                            </span>
                          </React.Fragment>
                        )}
                      {this.props.activeItem?.status?.name ===
                        Status.APPROVED && (
                          <React.Fragment>
                            <Icon
                              style={{ verticalAlign: "sub", color: "#0CA919" }}
                              name="abb/check-mark-circle-2"
                              sizeClass="medium"
                            />
                            <span
                              className="ml-1 fs-20"
                              style={{ fontSize: "24px" }}
                            >
                              <b>{t(Status.APPROVED)}</b>
                            </span>
                          </React.Fragment>
                        )}
                      {this.props.activeItem?.status?.name ===
                        Status.REJECTED && (
                          <React.Fragment>
                            <Icon
                              style={{ verticalAlign: "sub", color: "#F03040" }}
                              name="abb/error-circle-2"
                              sizeClass="medium"
                            />
                            <span
                              className="ml-1 fs-20"
                              style={{ fontSize: "24px" }}
                            >
                              <b>{t(Status.REJECTED)}</b>
                            </span>
                          </React.Fragment>
                        )}
                    </span>

                  </h4>
                </div>
                <div className="col-xl-7 col-lg-7 col-md-8 no-padding">
                  <ul className="navbar-nav mr-auto d-block float-right">
                    {(this.props.activeItem?.status == null ||
                      this.props.activeItem?.status.name ===
                      Status.NOTMEASURED) && (
                        <React.Fragment>
                          <Authorize scopes={[`${CONSTANTS.AUTHKEY_SAMPLE_MODE}:StartTest`]}>
                            <li className="nav-item">
                              <Button
                                type="primary-black"
                                className="spinner-position"
                                onClick={this.startMeasure}
                                shape={"pill"}
                                text={true && t(CONSTANTS.BUTTON_START)}
                                icon={true && "abb/play"}
                                disabled={
                                  this.state.sampleData?.testPlan &&
                                    this.state.sampleData?.sampleDate
                                    ? false
                                    : true
                                }
                                isLoading={this.state.startLoading}
                              />
                            </li>
                          </Authorize>
                        </React.Fragment>
                      )}
                    {this.props.activeItem?.status?.name ===
                      Status.MEASURING && (
                        <React.Fragment>
                          <li
                            className="nav-item"
                            onClick={this.measurementPause}
                          >
                            <Button
                              sizeClass="medium"
                              type="normal"
                              shape={"pill"}
                              className="spinner-position"
                              text={true && t(CONSTANTS.BUTTON_PAUSE)}
                              icon={true && "abb/pause"}
                              isLoading={this.state.pauseLoading}
                            />
                          </li>
                          <li className="nav-item" onClick={this.measurementStop}>
                            <Button
                              sizeClass="medium"
                              type="normal"
                              shape={"pill"}
                              className="spinner-position"
                              text={true && t(CONSTANTS.BUTTON_STOP)}
                              icon={true && "abb/stop"}
                              isLoading={this.state.stopLoading}
                            />
                          </li>
                        </React.Fragment>
                      )}
                    {this.props.activeItem?.status?.name == Status.PAUSED && (
                      <React.Fragment>
                        <li className="nav-item" onClick={this.measurementStop}>
                          <Button
                            icon={true && "abb/stop"}
                            sizeClass="medium"
                            className="spinner-position"
                            type="normal"
                            shape={"pill"}
                            text={t(CONSTANTS.BUTTON_STOP)}
                            isLoading={this.state.stopLoading}
                          />
                        </li>
                        <li
                          className="nav-item"
                          onClick={this.resumeMeasurement}
                        >
                          <Button
                            icon={true && "abb/play"}
                            sizeClass="medium"
                            className="spinner-position"
                            type="primary-black"
                            shape={"pill"}
                            text={t(CONSTANTS.BUTTON_RESUME)}
                            isLoading={this.state.resumeLoading}
                          />
                        </li>
                      </React.Fragment>
                    )}
                    {this.props.activeItem?.status?.name == Status.STOPPED && (
                      <React.Fragment>
                        <Authorize scopes={[`${CONSTANTS.AUTHKEY_SAMPLE_MODE}:ReMeasure`]}>
                          <li
                            className="nav-item"
                            onClick={(e) => this.reMeasure(e, true)}
                          >
                            <Button
                              icon={true && "abb/history"}
                              sizeClass="medium"
                              type="normal"
                              shape={"pill"}
                              text={t(CONSTANTS.BUTTON_REMEASURE)}
                              className="spinner-position"
                              isLoading={this.state.remeasureLoading && this.state.isSetActive}
                            />
                          </li>
                        </Authorize>
                        <Authorize scopes={[`${CONSTANTS.AUTHKEY_SAMPLE_MODE}:ClearData`]}>
                          <li
                            className="nav-item"
                            onClick={(e) => this.reMeasure(e, false)}
                          >
                            <Button
                              icon={true && "abb/refresh"}
                              sizeClass="medium"
                              type="normal"
                              shape={"pill"}
                              text={t(CONSTANTS.BUTTON_CLEAR_DATA)}
                              className="spinner-position"
                              isLoading={this.state.remeasureLoading && !this.state.isSetActive}
                            />
                          </li>
                        </Authorize>
                        <Authorize scopes={[`${CONSTANTS.AUTHKEY_SAMPLE_MODE}:Complete`]}>
                          <li
                            className="nav-item"
                            onClick={this.completeMeasurement}
                          >
                            <Button
                              icon={true && "abb/check-mark"}
                              sizeClass="medium"
                              type="normal"
                              shape={"pill"}
                              text={t(CONSTANTS.BUTTON_COMPLETE)}
                              className="spinner-position"
                              isLoading={this.state.completeLoading}
                            />
                          </li>
                        </Authorize>
                      </React.Fragment>
                    )}
                    {this.props.activeItem?.status?.name ==
                      Status.REMEASURE && (
                        <React.Fragment>
                          <li className="nav-item" onClick={this.measurementStop}>
                            <Button
                              icon={true && "abb/stop"}
                              sizeClass="medium"
                              type="normal"
                              shape={"pill"}
                              text={t(CONSTANTS.BUTTON_STOP)}
                              isLoading={this.state.stopLoading}
                              className="spinner-position"
                            />
                          </li>
                          <li
                            className="nav-item"
                            onClick={this.resumeMeasurement}
                          >
                            <Button
                              icon={true && "abb/play"}
                              sizeClass="medium"
                              type="normal"
                              shape={"pill"}
                              text={t(CONSTANTS.BUTTON_RESUME)}
                              isLoading={this.state.resumeLoading}
                              className="spinner-position"
                            />
                          </li>
                        </React.Fragment>
                      )}
                    {(this.props.activeItem?.status?.name == Status.MEASURED) && (
                      <React.Fragment>
                        <Authorize scopes={[`${CONSTANTS.AUTHKEY_SAMPLE_MODE}:ReMeasure`]}>
                          <li
                            className="nav-item"
                            onClick={(e) => this.reMeasure(e, true)}
                          >
                            <Button
                              icon={true && "abb/history"}
                              sizeClass="medium"
                              type="ghost"
                              shape={"pill"}
                              text={t(CONSTANTS.BUTTON_REMEASURE)}
                              className="spinner-position"
                              isLoading={this.state.remeasureLoading && this.state.isSetActive}
                            />
                          </li>
                        </Authorize>
                        {this.state.isSetActive &&
                          <React.Fragment>
                            <Authorize scopes={[`${CONSTANTS.AUTHKEY_SAMPLE_MODE}:ClearData`]}>
                              <li
                                className="nav-item"
                                onClick={(e) => this.reMeasure(e, false)}
                              >
                                <Button
                                  icon={true && "abb/refresh"}
                                  sizeClass="medium"
                                  type="ghost"
                                  shape={"pill"}
                                  text={t(CONSTANTS.BUTTON_CLEAR_DATA)}
                                  className="spinner-position"
                                  isLoading={this.state.remeasureLoading && !this.state.isSetActive}
                                />
                              </li>
                            </Authorize>
                            <Authorize scopes={[`${CONSTANTS.AUTHKEY_SAMPLE_MODE}:Complete`]}>
                              <li
                                className="nav-item"
                                onClick={this.completeMeasurement}
                              >
                                <Button
                                  icon={true && "abb/check-mark"}
                                  sizeClass="medium"
                                  type="ghost"
                                  shape={"pill"}
                                  text={t(CONSTANTS.BUTTON_COMPLETE)}
                                  className="spinner-position"
                                  isLoading={this.state.completeLoading}
                                />
                              </li>
                            </Authorize>
                            
                          </React.Fragment>
                        }
                        {!this.state.isSetActive &&
                          <React.Fragment>
                            <Authorize scopes={[`${CONSTANTS.AUTHKEY_SAMPLE_MODE}:Approve`]}>
                              <li
                                className="nav-item"
                                onClick={this.measurementApprove}
                              >
                                <Button
                                  sizeClass="medium"
                                  type="ghost"
                                  shape={"pill"}
                                  text={true && t(CONSTANTS.BUTTON_APPROVE)}
                                  icon={true && "abb/check-mark-circle-2"}
                                  className="spinner-position"
                                  isLoading={this.state.approveLoading}
                                />
                              </li>
                            </Authorize>
                            <Authorize scopes={[`${CONSTANTS.AUTHKEY_SAMPLE_MODE}:Reject`]}>
                              <li
                                className="nav-item"
                                onClick={this.measurementReject}
                              >
                                <Button
                                  sizeClass="medium"
                                  type="ghost"
                                  shape={"pill"}
                                  text={true && t(CONSTANTS.BUTTON_REJECT)}
                                  icon={true && "abb/error-circle-2"}
                                  className="spinner-position"
                                  isLoading={this.state.rejectLoading}
                                />
                              </li>
                            </Authorize>
                          </React.Fragment>
                        }
                      </React.Fragment>
                    )}
                    {(this.props.activeItem?.status?.name == Status.APPROVED || this.props.activeItem?.status?.name == Status.REJECTED) && (
                      <Authorize scopes={[`${CONSTANTS.AUTHKEY_SAMPLE_MODE}:ReMeasure`]}>
                        <li
                          className="nav-item"
                          onClick={(e) => this.reMeasure(e, true)}
                        >
                          <Button
                            icon={true && "abb/history"}
                            sizeClass="medium"
                            type="normal"
                            shape={"pill"}
                            text={t(CONSTANTS.BUTTON_REMEASURE)}
                            className="spinner-position"
                            isLoading={this.state.remeasureLoading && this.state.isSetActive}
                          />
                        </li>
                      </Authorize>
                    )}
                    <Authorize scopes={[`${CONSTANTS.AUTHKEY_SAMPLE_MODE}:Reports`]}>
                      <li className="nav-item">
                        <WithTooltip>
                          <Button
                            sizeClass="large"
                            type="discreet-black"
                            shape={"pill"}
                            icon={"abb/reports"}
                            onClick={this.onReportClick}
                            disabled={
                              this.props.activeItem?.status?.name == "Remeasure" ||
                              this.props.activeItem?.status?.name == "Measuring" ||
                              this.props.activeItem?.status?.name == "NotMeasured"
                            }
                            className="report-button"
                          />
                          <Tooltip className="pl-2 pr-2 pb-1 nav-tooltip">
                            <p>{t(CONSTANTS.REPORT)}</p>
                          </Tooltip>
                        </WithTooltip>
                      </li>
                    </Authorize>
                    {this.state.isReportDropdownShow &&
                      (this.props.activeItem?.status?.name == Status.MEASURED
                        || this.props.activeItem?.status?.name == Status.STOPPED
                        || this.props.activeItem?.status?.name == Status.PAUSED) && (
                        <div
                          className="ul-class "
                          style={{ right: 0, zIndex: 1000 }}
                        >
                          <Menu onLostFocus={this.onReportClick}>
                            <MenuItem
                              className="report-export"
                              text={t(CONSTANTS.VALUE_REPORT)}
                              onSelect={() =>
                                this.onReportLinkClick(CONSTANTS.VALUE_REPORT)
                              }
                            />
                            <MenuItem
                              className="report-export"
                              text={t(CONSTANTS.REEL_REPORT)}
                              onSelect={() =>
                                this.onReportLinkClick(CONSTANTS.REEL_REPORT)
                              }
                            />
                            <MenuItem
                              className="report-export"
                              text={t(CONSTANTS.POSITION_REPORT)}
                              onSelect={() =>
                                this.onReportLinkClick(
                                  CONSTANTS.POSITION_REPORT
                                )
                              }
                            />
                            <MenuItem
                              className="report-export"
                              text={t(CONSTANTS.GRAPH_REPORT)}
                              onSelect={() =>
                                this.onReportLinkClick(CONSTANTS.GRAPH_REPORT)
                              }
                            />
                          </Menu>
                        </div>
                      )}

                    {this.state.isReportDropdownShow &&
                      this.props.activeItem?.status?.name ==
                      Status.APPROVED && (
                        <div
                          className="ul-class "
                          style={{ right: 0 }}
                        >
                          <Menu onLostFocus={this.onReportClick}>
                            <MenuItem
                              className="report-export"
                              text={t(CONSTANTS.VALUE_REPORT)}
                              onSelect={() =>
                                this.onReportLinkClick(CONSTANTS.VALUE_REPORT)
                              }
                            />
                            <MenuItem
                              className="report-export"
                              text={t(CONSTANTS.REEL_REPORT)}
                              onSelect={() =>
                                this.onReportLinkClick(CONSTANTS.REEL_REPORT)
                              }
                            />
                            <MenuItem
                              className="report-export"
                              text={t(CONSTANTS.POSITION_REPORT)}
                              onSelect={() =>
                                this.onReportLinkClick(
                                  CONSTANTS.POSITION_REPORT
                                )
                              }
                            />
                            <MenuItem
                              className="report-export"
                              text={t(CONSTANTS.GRAPH_REPORT)}
                              onSelect={() =>
                                this.onReportLinkClick(CONSTANTS.GRAPH_REPORT)
                              }
                            />
                          </Menu>
                        </div>
                      )}

                    {this.state.isReportDropdownShow &&
                      this.props.activeItem?.status?.name ==
                      Status.REJECTED && (
                        <div
                          className="ul-class "
                          style={{ right: 0 }}
                        >
                          <Menu onLostFocus={this.onReportClick}>
                            <MenuItem
                              className="report-export"
                              text={t(CONSTANTS.VALUE_REPORT)}
                              onSelect={() =>
                                this.onReportLinkClick(CONSTANTS.VALUE_REPORT)
                              }
                            />
                            <MenuItem
                              className="report-export"
                              text={t(CONSTANTS.REEL_REPORT)}
                              onSelect={() =>
                                this.onReportLinkClick(CONSTANTS.REEL_REPORT)
                              }
                            />
                            <MenuItem
                              className="report-export"
                              text={t(CONSTANTS.POSITION_REPORT)}
                              onSelect={() =>
                                this.onReportLinkClick(
                                  CONSTANTS.POSITION_REPORT
                                )
                              }
                            />
                            <MenuItem
                              className="report-export"
                              text={t(CONSTANTS.GRAPH_REPORT)}
                              onSelect={() =>
                                this.onReportLinkClick(CONSTANTS.GRAPH_REPORT)
                              }
                            />
                          </Menu>
                        </div>
                      )}
                    {(this.state.exportSample || this.state.exportMeasurement) && (<Authorize scopes={[`${CONSTANTS.AUTHKEY_SAMPLE_MODE}:Export`]}>
                      <li className="nav-item">
                        <WithTooltip>
                          <Button
                            sizeClass="large"
                            type="discreet-black"
                            shape={"pill"}
                            icon={"abb/export"}
                            onClick={this.onExportCall}
                            disabled={!this.state.exportSample && (!this.state.exportMeasurement || this.props.activeItem.status.name === Status.NOTMEASURED)}
                          />
                          <Tooltip className="nav-tooltip">
                            <p>{t(CONSTANTS.EXPORT)}</p>
                          </Tooltip>
                        </WithTooltip>
                        {this.state.isExportShow && (
                          <div
                            className="ul-class "
                            style={{ right: 0, width: "200px" }}
                          >
                            <Menu onLostFocus={this.onExportCall}>
                              <MenuItem
                                text={t(CONSTANTS.MENU_EXPORT_SAMPLE)}
                                onSelect={this.onExportClick}
                                className="report-export"
                                disabled={!this.state.exportSample}
                              />
                              <MenuItem
                                text={t(CONSTANTS.MENU_EXPORT_MEASUREMENT)}
                                onSelect={this.onExportDataClick}
                                className="report-export"
                                disabled={!this.state.exportMeasurement || this.props.activeItem.status.name === Status.NOTMEASURED}
                              />
                            </Menu>
                          </div>
                        )}
                      </li>
                    </Authorize>)}
                    <li className="nav-item">
                      <WithTooltip>
                        <Button
                          sizeClass="medium"
                          type="discreet-black"
                          shape={"pill"}
                          icon={"abb/menu-narrow"}
                          onClick={this.onEditCall}
                        />
                        <Tooltip className="nav-tooltip">
                          <p>{t(CONSTANTS.MORE)}</p>
                        </Tooltip>
                      </WithTooltip>
                      {this.state.isEditShow && (
                        <div
                          className="ul-class "
                          style={{
                            marginLeft: -75,
                          }}
                        >
                          <Menu onLostFocus={this.onEditCall}>
                            <MenuItem
                              text={t(CONSTANTS.EDIT)}
                              onSelect={this.onEditClick}
                              className="report-export"
                              disabled={
                                this.props.activeItem?.status.name ===
                                Status.MEASURING || !authUtility.hasPermission([`${CONSTANTS.AUTHKEY_SAMPLE_MODE}:Edit`])
                              }
                            />
                            <MenuItem
                              className="report-export"
                              disabled={
                                this.props.activeItem?.status.name ===
                                Status.MEASURING || !authUtility.hasPermission([`${CONSTANTS.AUTHKEY_SAMPLE_MODE}:Delete`])
                              }
                              text={t(CONSTANTS.DELETE)}
                              onSelect={this.openDeleteDialog}
                            />
                          </Menu>
                        </div>
                      )}
                    </li>
                  </ul>
                </div>
              </div>
              <div className="row mx-1 py-2 px-0">
                <Summary>
                  <ul className="navbar-nav summaryList">
                    <li>
                      <span className="tagName">
                        {t(CONSTANTS.LABEL_DATECREATED)}
                      </span>
                      <span className="bolder-font-sample" style={{width: this.props.activeItem?.formatedDate && this.props.activeItem?.formatedDate.length > 20 ? '9vw' : 'auto'}}>{this.props.activeItem?.formatedDate}</span>
                    </li>
                    <li>
                      {this.props.activeItem?.source?.name && (
                        <React.Fragment>
                          <span className="tagName">
                            {t(CONSTANTS.LABEL_SOURCE)}
                          </span>
                          <span className="bolder-font-sample" style={{width: this.props.activeItem?.source?.name && this.props.activeItem?.source?.name.length > 20 ? '9vw' : 'auto'}}>{this.props.activeItem?.source?.name}</span>
                        </React.Fragment>
                      )}
                    </li>
                    <li>
                      {this.props.activeItem?.orderId && (
                        <React.Fragment>
                          <span className="tagName">
                            {t(CONSTANTS.LABEL_ORDERID)}
                          </span>
                          <span className="bolder-font-sample" style={{width: this.props.activeItem?.orderId && this.props.activeItem?.orderId.length > 20 ? '9vw' : 'auto'}}>{this.props.activeItem?.orderId}</span>
                        </React.Fragment>
                      )}
                    </li>
                    <li>
                      {this.props.activeItem?.product?.name && (
                        <React.Fragment>
                          <span className="tagName">
                            {t(CONSTANTS.MODULE_PRODUCT)}
                          </span>
                          <span className="bolder-font-sample" style={{width: this.props.activeItem?.product?.name && this.props.activeItem?.product?.name.length > 20 ? '9vw' : 'auto'}}>{this.props.activeItem?.product?.name}</span>
                        </React.Fragment>
                      )}
                    </li>
                    <li>
                      {this.props.activeItem?.grade?.name && (
                        <React.Fragment>
                          <span className="tagName">
                            {t(CONSTANTS.MODULE_GRADE)}
                          </span>
                          <span className="bolder-font-sample" style={{width: this.props.activeItem?.grade?.name && this.props.activeItem?.grade?.name.length > 20 ? '9vw' : 'auto'}}>
                            {this.props.activeItem?.grade?.name}
                          </span>
                        </React.Fragment>
                      )}
                    </li>
                    <li>
                      {this.props.activeItem?.testPlan?.name && (
                        <React.Fragment>
                          <span className="tagName">
                            {t(CONSTANTS.MODULE_TESTPLAN)}
                          </span>
                          <span className="bolder-font-sample" style={{width: this.props.activeItem?.testPlan?.name && this.props.activeItem?.testPlan?.name.length > 20 ? '9vw' : 'auto'}}>{this.props.activeItem?.testPlan?.name}</span>
                        </React.Fragment>
                      )}
                    </li>
                    <li>
                      <React.Fragment>
                        <span className="tagName">{t("Mode ")}</span>
                        {this.state.sampleData &&
                          this.state.sampleData.testPlan &&
                          this.state.sampleData.testPlan.isPDC
                          ? <span className="bolder-font-sample">{"P>D>C"}</span>
                          : <span className="bolder-font-sample">{"D>P>C"}</span>}
                      </React.Fragment>
                    </li>
                    <li style={{ display: "flex !important" }}>
                      {this.props.activeItem?.description && (
                        <React.Fragment>
                          <span className="tagName">
                            {t(CONSTANTS.MODULE_REMARKS)}
                          </span>
                          <span className="ellipsis-single-line bolder-font-sample" style={{width: this.props.activeItem?.description && this.props.activeItem?.description.length > 20 ? '9vw' : 'auto'}}>
                            {this.props.activeItem?.description}
                          </span>
                        </React.Fragment>
                      )}
                    </li>
                  </ul>
                </Summary>
              </div>
              <div className="content-body">
                {
                  this.state.isInstrumentPropertyDetails ? (
                    <Suspense
                      fallback={<div>{t(CONSTANTS.LOADING_INDICATOR)}</div>}
                    >
                      <InstrumentPropertyDetails
                        {...instrumentPropertyDetailsProps}
                      ></InstrumentPropertyDetails>
                    </Suspense>
                  ) : this.state.isInstrumentProperty ? (
                    <Suspense
                      fallback={<div>{t(CONSTANTS.LOADING_INDICATOR)}</div>}
                    >
                      <InstrumentProperty
                        {...instrumentPropertyProps}
                      ></InstrumentProperty>
                    </Suspense>
                  ) : this.state.isKeyedInPropertyDetails ? (
                    <Suspense
                      fallback={<div>{t(CONSTANTS.LOADING_INDICATOR)}</div>}
                    >
                      <KeyedInPropertyDetails
                        {...keyedInPropertyDetailsProps}
                      ></KeyedInPropertyDetails>
                    </Suspense>
                  ) : this.state.isKeyedInProperty ? (
                    <Suspense
                      fallback={<div>{t(CONSTANTS.LOADING_INDICATOR)}</div>}
                    >
                      <KeyedInProperty
                        {...keyedInPropertyProps}
                      ></KeyedInProperty>
                    </Suspense>
                  ) : this.state.isCalculatedPropertyDetails ? (
                    <Suspense
                      fallback={<div>{t(CONSTANTS.LOADING_INDICATOR)}</div>}
                    >
                      <CalculatedPropertyDetails
                        {...calculatedPropertyDetailsProps}
                      ></CalculatedPropertyDetails>
                    </Suspense>
                  ) : this.props.activeItem?.status?.name === "NotMeasured" ? (
                    <Suspense
                      fallback={<div>{t(CONSTANTS.LOADING_INDICATOR)}</div>}
                    >
                      <MeasurementLanding
                        {...measurementLandingProps}
                      ></MeasurementLanding>
                    </Suspense>
                  ) : this.props.activeItem?.status?.name === "Measuring" ||
                    this.props.activeItem?.status?.name === "Paused" ||
                    this.props.activeItem?.status?.name === "Stopped" ? (
                    <Suspense
                      fallback={<div>{t(CONSTANTS.LOADING_INDICATOR)}</div>}
                    >
                      <MeasurementTable
                        {...measurementTableProps}
                      ></MeasurementTable>
                    </Suspense>
                  ) : !this.state.isSetActive ? (
                    <Suspense
                      fallback={<div>{t(CONSTANTS.LOADING_INDICATOR)}</div>}
                    >
                      <MeasurementOverview
                        {...measurementOverviewProps}
                      ></MeasurementOverview>
                    </Suspense>
                  ) : (
                    <Suspense
                      fallback={<div>{t(CONSTANTS.LOADING_INDICATOR)}</div>}
                    >
                      <MeasurementTable
                        {...measurementTableProps}
                      ></MeasurementTable>
                    </Suspense>
                  )
                }
              </div>
            </div>

            <Dialog
              isOpen={this.state.showStopDialog}
              // tslint:disable-next-line: jsx-no-lambda
              onClose={() => this.setState({ showStopDialog: false })}
              showCloseButton={true}
              closeOnEscape={false}
              closeOnLostFocus={false}
              dimBackground={true}
              title={t(CONSTANTS.SAMPLE_MEASUREMENT_STOPPED_MSG)}
              standardButtonsOnBottom={[
                {
                  text: t(CONSTANTS.BUTTON_CANCEL),
                  type: "discreet-blue",
                  handler: (dlg) => dlg.close(),
                },
                {
                  text: t(CONSTANTS.BUTTON_OK),
                  type: "primary-blue",
                  handler: this.onMeasurementStopOkClick,
                },
              ]}
            />

            <Dialog
              isOpen={this.state.showPauseDialog}
              // tslint:disable-next-line: jsx-no-lambda
              onClose={() => this.setState({ showPauseDialog: false })}
              showCloseButton={true}
              closeOnEscape={false}
              closeOnLostFocus={false}
              dimBackground={true}
              title={t(CONSTANTS.SAMPLE_MEASUREMENT_PAUSE_MSG)}
              standardButtonsOnBottom={[
                {
                  text: t(CONSTANTS.BUTTON_CANCEL),
                  type: "discreet-black",
                  handler: (dlg) => dlg.close(),
                },
                {
                  text: t(CONSTANTS.BUTTON_OK),
                  type: "primary-black",
                  handler: this.onMeasurementPauseOkClick,
                },
              ]}
            >
            </Dialog>
            <Dialog
              isOpen={this.state.showRemeasureDialog}
              // tslint:disable-next-line: jsx-no-lambda
              onClose={this.reMeasureCancelClick}
              showCloseButton={true}
              closeOnEscape={false}
              closeOnLostFocus={false}
              dimBackground={true}
              title={t(this.state.shadowIsSetActive ? CONSTANTS.SAMPLE_MEASUREMENT_SETACTIVE_MSG : CONSTANTS.SAMPLE_MEASUREMENT_REMEASURE_MSG)}
              standardButtonsOnBottom={[
                {
                  text: t(CONSTANTS.BUTTON_CANCEL),
                  type: "discreet-blue",
                  handler: this.reMeasureCancelClick,
                },
                {
                  text: t(CONSTANTS.BUTTON_OK),
                  type: "primary-blue",
                  handler: this.onRemeasureOkClick,
                },
              ]}
            >
              <div>{t(this.state.shadowIsSetActive ? CONSTANTS.SAMPLE_MEASUREMENT_SETACTIVE_DATA : CONSTANTS.MSG_CURRENT_MEASURED_DATA)}.</div>
            </Dialog>
            <Dialog
              isOpen={this.state.showInstrumentRemeasureDialog}
              // tslint:disable-next-line: jsx-no-lambda
              onClose={() =>
                this.setState({ showInstrumentRemeasureDialog: false })
              }
              showCloseButton={true}
              closeOnEscape={false}
              closeOnLostFocus={false}
              dimBackground={true}
              title={t(CONSTANTS.SAMPLE_INSTRUMENT_REMEASURE_MSG)}
              standardButtonsOnBottom={[
                {
                  text: t(CONSTANTS.BUTTON_CANCEL),
                  type: "discreet-blue",
                  handler: (dlg) => dlg.close(),
                },
                {
                  text: t(CONSTANTS.BUTTON_OK),
                  type: "primary-blue",
                  handler: this.remeasureAfterConfirmation,
                },
              ]}
            ></Dialog>

            <Dialog
              isOpen={this.state.showInstrumentStopDialog}
              // tslint:disable-next-line: jsx-no-lambda
              onClose={() => this.setState({ showInstrumentStopDialog: false })}
              showCloseButton={true}
              closeOnEscape={false}
              closeOnLostFocus={false}
              dimBackground={true}
              title={t(CONSTANTS.SAMPLE_INSTRUMENT_STOPPED_MSG)}
              standardButtonsOnBottom={[
                {
                  text: t(CONSTANTS.BUTTON_CANCEL),
                  type: "discreet-blue",
                  handler: (dlg) => dlg.close(),
                },
                {
                  text: t(CONSTANTS.BUTTON_OK),
                  type: "primary-blue",
                  handler: this.stopAfterConfirm,
                },
              ]}
            ></Dialog>

            <Dialog
              isOpen={this.state.deleteModalVisible}
              // tslint:disable-next-line: jsx-no-lambda
              onClose={() => this.setState({ deleteModalVisible: false })}
              showCloseButton={true}
              closeOnEscape={false}
              closeOnLostFocus={false}
              dimBackground={true}
              title={t(CONSTANTS.DELETE_TITLE, {
                name: this.state.deleteTitle,
              })}
              standardButtonsOnBottom={[
                {
                  text: t(CONSTANTS.BUTTON_CANCEL),
                  type: "discreet-blue",
                  handler: (dlg) => dlg.close(),
                },
                {
                  text: t(CONSTANTS.BUTTON_OK),
                  type: "primary-blue",
                  handler: this.onDeleteClick,
                },
              ]}
            >
              <div className="delete-popup-text-overflow-hidden">
                {t(CONSTANTS.DELETE_MESSAGE, {
                  name: this.state.deleteMessage,
                  module: t(this.state.moduleName),
                })}
                <br />
                <br />
                <b>{t(CONSTANTS.NOTE)}:</b> {t(CONSTANTS.DELETE_POPUP_MESSAGE)}
              </div>
            </Dialog>
          </div>
        )}
      </Translation>
    );
  }
}
	